import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu';
import 'react-datepicker/dist/react-datepicker.css';
import DocumentService from '../../Services/documents.service';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service';
import PuffLoader from "react-spinners/PuffLoader";
import { ToastContainer, toast } from "react-toastify";
import './AccountCardDashboard.css';
import ClientService from '../../Services/client.service';
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import DescriptionIcon from '@mui/icons-material/Description';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal';
import cardMatchingIcon from '../../assests/images/Icons/cardMatching.svg';
import { useBack } from "use-back";

import EditModal from '../../Components/EditModal/EditModal';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';
import CustomYearDatePicker from '../../Components/Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import FormControlLabel from '@mui/material/FormControlLabel';
import Constants from '../../assests/Constants/constants';
import useCaseSystemAccountSettings from '../../hooks/useCaseSystemAccountSettings';
import { TextField,  MenuItem, FormControl, InputLabel, Chip, OutlinedInput, Box } from '@mui/material';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Collapse, IconButton, Box as MuiBox, Checkbox, Button as MuiButton
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { beautifyNumber } from '../../Utils/FormatNumber';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { Edit as EditIcon } from '@mui/icons-material';
import CustomDropdown from '../../Components/CustomDropdown/CustomDropdown';
import Select, { components } from 'react-select';
import addIcon from "../../assests/images/plusO.png";
import cancelIcon from "../../assests/images/cancel.png";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import EditPaymentAcceptanceModal from '../../Components/EditPaymentAcceptanceModal/EditPaymentAcceptanceModal';
import AccountCardReportHTML from '../../Components/AccountCardDashboard/AccountCardReportHTML/AccountCardReportHTML';
import ProfitAndLossCardsReport from '../../Components/AccountCardDashboard/ProfitAndLossCardsReport/ProfitAndLossCardsReport';
import DenseTable from '../../Components/DenseTable/DenseTable';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails';
import AccountCardDashboardTable from '../../Components/AccountCardDashboard/SubComponents/AccountCardDashboardTable';
import AccountCardCollapsibleTable from '../../Components/AccountCardDashboard/SubComponents/AccountCardCollapsibleTable';
import BulkEditDialog from '../../Components/AccountCardsTable/SubComponents/BulkEditDialog.jsx';
import PaymentAcceptanceCreateEditModal from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceCreateEditModal';
import CustomMonthYearIndividualDatePicker from '../../Components/Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import { validateDocumentBeforeProcessing, validatePaymentAcceptanceItems } from '../../Utils/documentValidation'
import { canProcessDocumentStatus } from '../../Utils/helpers.js';
import { buildPaymentAcceptanceUpdatePayload } from '../../Utils/paymentAcceptanceUpdatePayload.js'
import ChooseAsset from '../../Components/Widgets/ChooseAsset/ChooseAsset';
import AssetService from '../../Services/assets.service';
import AddAssetGroup from '../../Components/Assets/SubComponents/AddAssetGroup';
import AssetFoundDialog from '../../Components/Widgets/AssetFoundDialog/AssetFoundDialog';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import FilterBar from '../../Components/AccountCardDashboard/FilterBar/FilterBar';
import SelectedCardsTitle from '../../Components/AccountCardDashboard/SelectedCardsTitle/SelectedCardsTitle';
import { PermissionsContext } from '../../Contexts/Permissions.js';
import { ROW_VIEW_MODES, collapseAccountCardRows } from '../../Utils/reconciliationSummary';
registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

// Helper function to adjust date to Israel time zone (UTC+2)
const adjustToIsraelTime = (date) => {
    const israelTimeOffset = 2 * 3600 * 1000; // 2 hours in milliseconds
    return new Date(date.getTime() + israelTimeOffset);
};

// Helper function to get the start of the year in Israel time
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1); // Jan 1st of the given year
    return adjustToIsraelTime(startOfYear);
};

// Helper function to get the current month in Israel time
const getCurrentMonth = (date) => {
    const currentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Last day of the current month
    return adjustToIsraelTime(currentMonth);
};



const formatDate = (startDate, endDate) => {
    const date = new Date(startDate);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const Enddate = new Date(endDate);
    const EndMonth = ('0' + (Enddate.getMonth() + 1)).slice(-2);
    const EndYear = Enddate.getFullYear();
    return `${EndMonth}/${EndYear} - ${month}/${year}`;
};

const formatYearRange = (dateRange) => {
    const [start, end] = dateRange.split(" - ");
    const startYear = new Date(start).getFullYear();
    const startMonth = new Date(start).getMonth() + 1; // getMonth() is zero-indexed
    const endMonth = new Date(end).getMonth() + 1;
    return `${startMonth}-${endMonth}/${startYear}`;
}

const formatDateNew = dateString => {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

const customStyles = {
    valueContainer: (base, state) => ({
        ...base,
        justifyContent: "center"
    }),
}

const dateTime = (value) => (value instanceof Date && !isNaN(value) ? value.getTime() : null);

/** Keeps the report filters prop identity stable while the values stay the same. */
const isSameReportFilters = (a, b) => (
    !!a && !!b
    && dateTime(a.startDate) === dateTime(b.startDate)
    && dateTime(a.endDate) === dateTime(b.endDate)
    && a.isMonthly === b.isMonthly
    && a.onlyProcessed === b.onlyProcessed
    && a.filterByDocumentDate === b.filterByDocumentDate
);



function AccountCardDashboard() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    // const [data, setData] = useState([]);
    const [client, setClient] = useState(null);
    const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);
    const [type, setType] = useState('');
    const { goBack } = useContext(NavHistoryContext);
    const { userTypeContext, permissionsState, clientPermissionsState } = useContext(PermissionsContext);
    const hideStatusBadge = clientPermissionsState?.CantSeeStatusDocuments &&
        userTypeContext?.toString() === Constants.UserType.Client;
    const canProcessStatus = canProcessDocumentStatus(userTypeContext, permissionsState, hideStatusBadge);
    // const dispatch = useDispatch();


    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const [startDate, setStartDate] = useState(() => {
        const stored = localStorage.getItem('StartDate');
        return stored ? new Date(stored) : new Date();  
    });

    const [endDate, setEndDate] = useState(() => {
        const stored = localStorage.getItem('EndDate');
        return stored ? new Date(stored) : new Date();
    });
    const [isMonthly, setIsMonthly] = useState(() => {
        return JSON.parse(localStorage.getItem('isMonthly')) || true;
    });
    const [data, setData] = useState([]);
    const [sortDate, setSortDate] = useState(new Date());
    const [startYearDate, setStartYearDate] = useState(new Date());
    const [endYearDate, setEndYearDate] = useState(new Date());
    const [sortCodesGroupOptions, setSortCodesGroupOptions] = useState([]);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [footerTotals, setFooterTotals] = useState({});

    const [responseData, setResponseData] = useState({});
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    //for item edit

    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [editedItem, setEditedItem] = useState({});
    const [statusCheck, setStatusCheck] = useState(false);
    /** EditModal opened from the P&L cards report — used to close only on Processed→Unprocessed save. */
    const editFromPlReportRef = useRef(false);
    const editOpenedAsProcessedRef = useRef(false);
    const [plReportReloadToken, setPlReportReloadToken] = useState(0);
    const [editingRow, setEditingRow] = useState(null);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [showType, setShowType] = useState({ type: 'all', index: -1 });

    const [fade, setFade] = useState(false);
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [editedJournalItem, setEditedJournalItem] = useState(true);
    const [processedFilesCheckbox, setProcessedFilesCheckbox] = useState(() => {
        const savedValue = localStorage.getItem('processedFilesCheckbox');
        return savedValue === null ? true : JSON.parse(savedValue);
    });

    // Toggles whether the report is filtered by document date instead of register month date.
    const [filterByDocumentDate, setFilterByDocumentDate] = useState(() => {
        const savedValue = localStorage.getItem('filterByDocumentDate');
        return savedValue === null ? true : JSON.parse(savedValue);
    });

    // Foreign-currency report filter. null = shekel (default, current behavior).
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    // Distinct foreign currencies present in the loaded data (for the currency selector).
    const [availableCurrencies, setAvailableCurrencies] = useState([]);

    useEffect(() => {
        localStorage.setItem('filterByDocumentDate', JSON.stringify(filterByDocumentDate));
    }, [filterByDocumentDate]);

    const prevFilterByDocumentDateRef = useRef(filterByDocumentDate);

    useEffect(() => {
        const prev = prevFilterByDocumentDateRef.current;
        prevFilterByDocumentDateRef.current = filterByDocumentDate;
        if (prev === filterByDocumentDate || !isMonthly) return;

        const start = startDate || new Date();
        const end = endDate || new Date();

        if (filterByDocumentDate) {
            const docStart = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 1));
            const docEnd = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1, 0));
            setStartDate(docStart);
            setEndDate(docEnd);
            localStorage.setItem('StartDate', docStart.toISOString());
            localStorage.setItem('EndDate', docEnd.toISOString());
            if (isDataFetched && client) {
                fetchAccountCardDashboard(docStart, docEnd, processedFilesCheckbox);
            }
        } else {
            const monthStart = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 10));
            const monthEnd = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), 10));
            setStartDate(monthStart);
            setEndDate(monthEnd);
            localStorage.setItem('StartDate', monthStart.toISOString());
            localStorage.setItem('EndDate', monthEnd.toISOString());
            if (isDataFetched && client) {
                fetchAccountCardDashboard(monthStart, monthEnd, processedFilesCheckbox);
            }
        }
    }, [filterByDocumentDate]);

    const { setMenuProps } = useHamburgerMenu();
    // setMenuProps({ client, showIcon: true });
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});

    //new constants
    const [focused, setFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const handleStartYearDate = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setStartYearDate(newDate);
    }


    const handleEndYearDate = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setEndYearDate(newDate);
    }





    const [saleEquipment, setSaleEquipment] = useState(false);
    const [dateForAsset, setDateForAsset] = useState(new Date().toISOString());
    const [typeToPassToChoose, setTypeToPassToChoose] = useState('');
    const [clickedAsset, setClickedAsset] = useState(null);

    const isPurchaseOfEquipment = (item) => {


        if (!item) return false; // If the item is not found, allow processing
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === item.sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing



        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };

    const isDepreciationDocument = (editedItem, sortCodeId) => {
        const item = editedItem;
        const itemId = editedItem.id;
        if (!item) return false; // If the item is not found, allow processing
        setItemForAssets(item);
        setDateForAsset(item.documentDate);
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing

        const isItemUsedInAssets = assets.some(
            (asset) => asset.expenseId === itemId || asset.journalEntryId === itemId
        );


        const name = sortCode.sortCodeName?.trim().replace(/\s+/g, ' ') || "";
        const saleEquipmentRegex = /(מכירה|מכירת).*ציוד|ציוד.*(מכירה|מכירת)/;
        if (sortCode.sortCodeId === caseSystemSettings.fixedAssetSaleSortCode || saleEquipmentRegex.test(name)) {

            setSaleEquipment(true);
            return true;
        }


        setSaleEquipment(false);
        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    }
    const [showChooseAsset, setShowChooseAsset] = useState(false);
    const [itemToAddToAsset, setItemToAddToAsset] = useState('');
    const [itemForAssets, setItemForAssets] = useState({});



    const handleAssetClicked = (asset, item) => {
        setItemToAddToAsset(item.id);
        setItemForAssets(item)
        setClickedAsset(asset);
        setShowChooseAsset(true);
    }

    const handleAssetClose = () => {
        setShowChooseAsset(false);
        setClickedAsset(null);
    }


    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });
    const handleCancel = () => {
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
        editFromPlReportRef.current = false;
        editOpenedAsProcessedRef.current = false;
    };


    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '' })
        setEditedAddAccountCard(false);
    };

    useEffect(() => {
        if (currentIndex != -1) {
            setFade(true);
            const timer = setTimeout(() => setFade(false), 500);
            return () => clearTimeout(timer);
        }
    }, [currentIndex]);
    const handleEditAddAccountChange = (selectedOption, field) => {

        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'AccountCodeName') {
            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };



    const updateAccountFields = (newValue, accountType) => {


        const isIncomesDebit = editedItem.docType === 'Incomes' && accountType === 'debitAccount';
        const isExpensesCredit = editedItem.docType === 'Expenses' && accountType === 'creditAccount';

        const updatedFields = {
            accountCodeId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.cardId : '') : '',
            accountCodeName: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.name : '') : '',
            accountCaseId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.accountCaseId : '') : '',
        };

        // Update the edited item with the new fields
        setEditedItem((prev) => ({
            ...prev,
            [accountType]: newValue ? newValue.cardId : '',
            ...(isIncomesDebit || isExpensesCredit ? updatedFields : {}),
        }));
    };

    const { hasBack, handleBack } = useBack();
    const [showAssetFoundDialog, setShowAssetFoundDialog] = useState(false);
    const [foundAsset, setFoundAsset] = useState(null);

    const fetchEnumsNoParams = async () => {
        await fetchEnums(user, token, client);
    }

    const handleChange = (field, value) => {

        const updatedValue = value;

        if (field === 'sortCodeId') {
            let depreciation = false;
            if (isDepreciationDocument(editedItem, value)) {
                depreciation = true;
                setItemToAddToAsset(editedItem.id);
                setShowChooseAsset(true);

            }

            if (isPurchaseOfEquipment(editedItem) && !depreciation) {
                if (assets) {
                    const assetFound = assets.find(
                        (asset) => asset.expenseId === editedItem.id || asset.journalEntryId === editedItem.id
                    );
                    if (assetFound) {

                        setFoundAsset(assetFound);
                        setShowAssetFoundDialog(true);
                    }
                }
            }

            if (!value || !sortCodeIdOptions.some((option) => option.sortCodeId === value)) {
                // Set default values for the empty state
                setEditedItem({
                    ...editedItem,
                    vat: 100, // Default VAT
                    [field]: '',
                });
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.sortCodeId === value
            )?.sortCodeName || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === updatedValue)[0];

            const newVat = sortCode?.vat ?? 100;

            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode.debitAccount : sortCode.creditAccount)
            );
            setEditedItem({
                ...editedItem,
                vat: newVat,
                [field]: updatedValue,
                [type === 'Incomes' ? 'debitAccount' : 'creditAccount']:
                    editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount']
                        ? (accountCard ? accountCard.cardId : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'])
                        : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'],
                accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                accountCaseId: accountCard ? accountCard.accountCaseId : editedItem.accountCaseId,
            });

        }
        else if (field === 'creditAccount' || field === 'debitAccount') {

            // Use the helper function to update account fields for credit or debit account
            const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
            updateAccountFields(newValue, field);
        }
        else {
            // For fields other than sortCodeId, just update the edited item
            setEditedItem({
                ...editedItem,
                [field]: updatedValue,
            });
        }
    };
    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };

    const handleReopenEdit = async (item, index) => {
        await fetchEnums(user, token, client);
        item.key = item.id;
        handleEdit(item);
    };


    const handleAccountChange = (selectedOption, field) => {
        if (field === 'debitAccount' || field === 'creditAccount') {
            const accountCardEditDownload = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value);
            const name = accountCardEditDownload?.name;
            const accountCaseId = accountCardEditDownload?.accountCaseId;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedItem.cardId)
            }
            if (editedItem.docType === 'Incomes') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: accountCaseId })
            }
            else if (editedItem.docType === 'Expenses') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: accountCaseId });
            }
            else if (editedItem.docType === 'JournalEntries') {
                setEditedItem({
                    ...editedItem,
                    [field]: selectedOption.value
                });
            }
        } else if (field === 'accountCodeName') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' })
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === selectedOption.value
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = selectedOption.value;
                if (editedItem.docType === 'Incomes') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, debitAccount: cardId, accountCaseId: accountCaseId })
                }
                else if (editedItem.docType === 'Expenses') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, creditAccount: cardId, accountCaseId: accountCaseId });
                }
                else if (editedItem.docType === 'JournalEntries') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, accountCaseId: accountCaseId })
                }
            }
        }
    };
    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return
            }
            else {
                setEditedItem({ ...editedItem, [field]: newDate });
            }
        }
    }

    const handleRadioPAChange = async (e) => {
        if (e.target.value?.toString() === 'done') {
            const isValid = await validatePaymentAcceptanceItems(addEditableItem, t, client);
            if (!isValid) return;

            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }
        setAddEditableItem({ ...addEditableItem, ["status"]: e.target.value });
    };

    const handleRadioChange = async (e, options = {}) => {
        if (!canProcessStatus) {
            return;
        }
        if (e.target.value?.toString() === 'done' && !options?.validationAlreadyDone) {

            const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true);
            if (!isValid) return;
        }

        if (e.target.value?.toString() === 'done') {
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };
    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };
    const handleUpdate = async (itemId) => {
        
        setLoading(true);
        let finalResponse = null;
        const toastPosition = direction === 'rtl' ? 'top-left' : 'top-right';
        // setEditedPopupItem(false);
        try {
            editedItem.accountCaseId = client.accountCaseId;
            delete editedItem.documentUrl; // Ensure the document URL is not part of the update if present

            setTypeToPassToChoose(editedItem.docType);

            finalResponse = await DocumentService.UpdateDocument(editedItem.docType, token, editedItem);
            if (finalResponse && finalResponse.ok) {
                if (canProcessStatus) {
                    if (editedItem.status === 'done') {
                        await handleDoneClick(editedItem.id, editedItem.docType);
                        handleSortChange('id', 'newest', 'descending');
                    } else if (editedItem.status === 'notDone') {
                        await handleNotDoneClick(editedItem.id, editedItem.docType);
                    }
                }

                if (editedAddAccountCard) {
                    await handleAccountCardSave(editedItem.accountCodeId, editedItem.accountCodeName, editedItem.accountCaseId);
                    await fetchEnums(user, token, client);
                }

                // Fetch the updated document to get the fresh data including documentUrl
                // From the P&L report: closing EditModal only when the user converted
                // Processed → Unprocessed and saved. Any other save leaves the modal open.
                const closeAfterUnprocessFromPl =
                    editFromPlReportRef.current
                    && editOpenedAsProcessedRef.current
                    && editedItem.status === 'notDone';

                if (closeAfterUnprocessFromPl) {
                    handleCancel();
                } else {
                    try {
                        const updatedDocumentResponse = await DocumentService.GetDocumentById(editedItem.docType, client.caseId, editedItem.id, token);
                        if (updatedDocumentResponse && updatedDocumentResponse.ok) {
                            const updatedDocument = await updatedDocumentResponse.json();
                            setEditedItem(updatedDocument); // Update the editedItem with fresh data
                        }
                    } catch (fetchError) {
                        console.error("Error fetching updated document:", fetchError);
                        // Continue with the flow even if fetching updated document fails
                    }
                }

                if (editFromPlReportRef.current || closeAfterUnprocessFromPl) {
                    setPlReportReloadToken((prev) => prev + 1);
                }

                const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                    ? endDate
                    : new Date(Date.UTC(startDate.getFullYear(), 11, 31));
                setEndDate(finalEndDate);
                localStorage.setItem('EndDate', finalEndDate);
                await fetchAccountCardDashboard(new Date(startDate), new Date(endDate));
                toast.success(t("documentUpdateSuccess"), { position: toastPosition });
            } else {
                const errorText = await finalResponse.text();
                toast.error(t("documentUpdateError") + ": " + errorText, { position: toastPosition });
            }
        } catch (error) {
            // This block catches unexpected errors such as network issues, not HTTP errors which are handled above
            console.error("Unexpected error occurred: ", error);
            toast.error(t("documentUpdateError"), { position: toastPosition });
        }
        // setEditedItem({});
        // setEditingRow(null);
        // setEditedAddAccountCard(false);
        setLoading(false); // Always stop loading at the end of the operation
    };

    const handleDoneClick = async (itemId, docType) => {
        if (!canProcessStatus) {
            return;
        }
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, docType, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };
    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        } else if (sortConfig.key === key && sortConfig.direction === 'descending') {
            direction = 'ascending';
        }
        setSortConfig({ key, direction, type });
    };

    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };
        setClient(enrichedClient);
    }
    const handleNotDoneClick = async (itemId, docType) => {
        if (!canProcessStatus) {
            return;
        }
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, docType, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };
    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, AccountCaseId) => {
        const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, AccountCaseId, token);
        if (!response2.ok) {
            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const [assets, setAssets] = useState([]);


    const [assetGroups, setAssetGroups] = useState([]);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);

    const handleOpenGroudAdd = () => {
        setShowAddGroupModal(true);
    }


    //FetchEnums
    const fetchEnums = async (user, token, client) => {
        setLoading(true);
        try {
            const sortCodeGroupResponse = await EnumsService.GetSortCodesGroupByAccountantId(client.accountantId, token);
            const sortCodeGroupData = await sortCodeGroupResponse.json();
            setSortCodesGroupOptions(sortCodeGroupData);

            // Fetching sortCodeIdOptions
            const codeIdResponse = await EnumsService.GetSortCodesByAccountantId(client.accountantId, token);
            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();
                setSortCodeIdOptions(codeIdData); // Assuming codeIdData is already in the correct format
            }


            // Fetching creditAccountOptions and debitAccountOptions
            const accountsResponse = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData); // Assuming both options are the same
                setAccountCardEditDownloadOptions(accountsData);
                const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];

                setAccountCardOptions(accountCardOptions);
                
                // Set all account cards for range selection
                setAllAccountCards(accountsData);
                
                // If we're in multi-card mode and no cards are selected yet, initialize
                if (isMultiCardReport && selectedCards.length === 0) {
                    if (cardSelectionMode === 'all') {
                        setSelectedCards(accountsData);
                    } else if (cardSelectionMode === 'range' && fromCard && toCard) {
                        const fromIndex = accountsData.findIndex(card => card.cardId === fromCard.cardId);
                        const toIndex = accountsData.findIndex(card => card.cardId === toCard.cardId);
                        if (fromIndex !== -1 && toIndex !== -1) {
                            const start = Math.min(fromIndex, toIndex);
                            const end = Math.max(fromIndex, toIndex);
                            setSelectedCards(accountsData.slice(start, end + 1));
                        }
                    }
                }
            }
            // Fetch PAL code categories first (needed for sorting)
            const palCodeCategoriesResponse = await EnumsService.GetPalCodeCategoriesByAccountantId(client.accountantId, token);
            
            let palCodeCategoriesData = [];
            if (palCodeCategoriesResponse.ok) {
                palCodeCategoriesData = await palCodeCategoriesResponse.json();
                setPalCodeCategoryOptions(palCodeCategoriesData);
            }

            const palCodesResponse = await EnumsService.GetPalCodesByAccountantId(client.accountantId, token)
            // Process palCodes if response is okay
            if (palCodesResponse.ok) {
                const palCodesData = await palCodesResponse.json();
                
                const PAL_CODE_TYPE_SORT_ORDER = {
                    'מאזני': 0,
                    'מאזני רכוש קבוע': 1,
                    'תוצאתי': 2,
                };

                const sortedPalCodes = [...palCodesData].sort((a, b) => {
                    const typeOrderA = PAL_CODE_TYPE_SORT_ORDER[a.palCodeType] ?? 999;
                    const typeOrderB = PAL_CODE_TYPE_SORT_ORDER[b.palCodeType] ?? 999;
                    if (typeOrderA !== typeOrderB) {
                        return typeOrderA - typeOrderB;
                    }

                    const orderA = a.orderNumber ?? 9999;
                    const orderB = b.orderNumber ?? 9999;
                    return orderA - orderB;
                });
                
                const formattedPalCodes = sortedPalCodes.map(palCode => ({
                    label: palCode.palCodeId,
                    value: palCode.palCodeId,
                    palCodeType: palCode.palCodeType,
                    orderNumber: palCode.orderNumber,
                }));
                setFormattedPalCodeOptions(formattedPalCodes);
                setPalCodeOptions(formattedPalCodes);
            }


            const assetGroupResponse = await AssetService.GetAllAssetGroups(client?.caseId, token);
            if (assetGroupResponse.success) {

                setAssetGroups(assetGroupResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }
            const assetResponse = await AssetService.GetAllAssets(client?.caseId, token);
            if (assetResponse.success) {
                setAssets(assetResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }


            setIsDataFetched(true);
            // toast.success(t('enumFetchSuccess'));
        } catch (error) {
            console.error("Error fetching enum data:", error);
            toast.error(`${t("Error fetching enum data")}: ${error}`);
        }
        setLoading(false);
    };



    const monthlyRangeRef = useRef({ start: startDate, end: endDate });
    const isLedgerNavigationRef = useRef(false);
    const handleRangeChange = (monthly) => {
        setIsMonthly(prev => {
            if (monthly === prev) return prev;
            const next = monthly;
            localStorage.setItem('isMonthly', JSON.stringify(next));
            if (prev) {
                /* leaving MONTHLY → YEARLY : cache the monthly dates */
                monthlyRangeRef.current = { start: startDate, end: endDate };

                // Use UTC + day 10 for start (same as handleStartDateChange) so
                // toISOString() stays in the selected calendar year (avoids Israel TZ shift to Dec 31 prior year).
                const year = startDate.getUTCFullYear();
                const y1 = new Date(Date.UTC(year, 0, 10, 0, 0, 0, 0));
                const y2 = new Date(Date.UTC(year, 11, 31, 0, 0, 0, 0));

                setStartYearDate(y1);
                setEndYearDate(y2);
                setStartDate(y1);
                setEndDate(y2);

                localStorage.setItem('StartDate', y1.toISOString());
                localStorage.setItem('EndDate', y2.toISOString());
            } else {
                /* returning YEARLY → MONTHLY : restore the cached dates */
                const { start, end } = monthlyRangeRef.current;
                if (start && end) {
                    setStartDate(start);
                    setEndDate(end);
                    localStorage.setItem('StartDate', start.toISOString());
                    localStorage.setItem('EndDate', end.toISOString());
                }
            }
            return next;
        });
    };

    useEffect(() => {
        if (isLedgerNavigationRef.current) {
            isLedgerNavigationRef.current = false;
            return;
        }
        if (client) {
            refreshData();
        }
    }, [isMonthly]);

    const handleEndDateChange = async (date) => {
        if (!date) return;

        if (filterByDocumentDate && isMonthly) {
            setEndDate(date);
            localStorage.setItem('EndDate', date.toISOString());
            fetchAccountCardDashboard(startDate || new Date(), date, processedFilesCheckbox);
            return;
        }

        const newDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 10, 0, 0, 0, 0));
        let endDateToSet;

        // Handle null startDate by using current date as fallback
        const currentStartDate = startDate || new Date();

        if (isMonthly) {
            endDateToSet = newDate;
            setEndDate(newDate);
            localStorage.setItem('EndDate', newDate.toISOString());

        } else {
            endDateToSet = date;
            setEndYearDate(endDateToSet);
            setEndDate(endDateToSet);
            localStorage.setItem('EndDate', endDateToSet.toISOString());

        }

        // Call fetchAccountCardDashboard after updating the end date
        const startOfYear = new Date(Date.UTC(currentStartDate.getUTCFullYear(), 0, 1, 0, 0, 0, 0));
        fetchAccountCardDashboard(isMonthly ? currentStartDate : startYearDate, endDateToSet, processedFilesCheckbox);
    };

    const handleStartDateChange = async (date) => {
        if (!date) return;

        if (filterByDocumentDate && isMonthly) {
            setStartDate(date);
            localStorage.setItem('StartDate', date.toISOString());
            fetchAccountCardDashboard(date, endDate || new Date(), processedFilesCheckbox);
            return;
        }

        const newDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 10, 0, 0, 0, 0));
        let startDateToSet;
        let finalEndDate;
        let endOfYear;

        // Handle null endDate by using current date as fallback
        const currentEndDate = endDate || new Date();

        if (isMonthly) {
            startDateToSet = newDate;
            setStartDate(newDate);
            localStorage.setItem('StartDate', newDate.toISOString());
        } else {

            startDateToSet = new Date(Date.UTC(date.getUTCFullYear(), 0, 10, 0, 0, 0, 0));
            setStartYearDate(startDateToSet);
            endOfYear = date;


            setEndYearDate(endOfYear);
            setStartDate(startDateToSet);
            setEndDate(endOfYear);
            localStorage.setItem('EndDate', endOfYear.toISOString());
            localStorage.setItem('StartDate', startDateToSet.toISOString());
        }

        // Call fetchAccountCardDashboard after updating the start date
        finalEndDate = isMonthly ? currentEndDate : endOfYear;
        fetchAccountCardDashboard(startDateToSet, finalEndDate, processedFilesCheckbox);
    };

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        let startDateToSet;

        // Handle null startDate by using current date as fallback
        const currentStartDate = startDate || new Date();
        const currentEndDate = endDate || new Date();

        if (type === 'year') {
            // When year changes, keep the current month (use UTC methods)
            const currentMonth = currentStartDate.getUTCMonth();
            updatedDate = new Date(Date.UTC(newDate.getUTCFullYear(), currentMonth, 10, 0, 0, 0, 0));
        } else if (type === 'month') {
            // When month changes, keep the current year (use UTC methods)
            const currentYear = currentStartDate.getUTCFullYear();
            updatedDate = new Date(Date.UTC(currentYear, newDate.getUTCMonth(), 10, 0, 0, 0, 0));
        }

        if (isMonthly) {
            startDateToSet = updatedDate;
            setStartDate(updatedDate);
            localStorage.setItem('StartDate', updatedDate.toISOString());
        } else {
            startDateToSet = new Date(Date.UTC(newDate.getUTCFullYear(), 0, 1, 0, 0, 0, 0));
            setStartYearDate(startDateToSet);
            setStartDate(startDateToSet);
            localStorage.setItem('StartDate', startDateToSet.toISOString());
        }

        // Save the updated date in localStorage for persistence
        const endOfYear = new Date(Date.UTC(currentEndDate.getUTCFullYear(), 11, 31, 0, 0, 0, 0));
        fetchAccountCardDashboard(startDateToSet, isMonthly ? currentEndDate : endYearDate, processedFilesCheckbox);
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        let endDateToSet;

        // Handle null endDate by using current date as fallback
        const currentEndDate = endDate || new Date();
        const currentStartDate = startDate || new Date();

        if (type === 'year') {
            // When year changes, keep the current month (use UTC methods)
            const currentMonth = currentEndDate.getUTCMonth();
            updatedDate = new Date(Date.UTC(newDate.getUTCFullYear(), currentMonth, 10, 0, 0, 0, 0));
        } else if (type === 'month') {
            // When month changes, keep the current year (use UTC methods)
            const currentYear = currentEndDate.getUTCFullYear();
            updatedDate = new Date(Date.UTC(currentYear, newDate.getUTCMonth(), 10, 0, 0, 0, 0));
        }

        if (isMonthly) {
            endDateToSet = updatedDate;
            setEndDate(updatedDate);
            localStorage.setItem('EndDate', updatedDate.toISOString());
        } else {
            endDateToSet = newDate;
            setEndYearDate(endDateToSet);
            setEndDate(endDateToSet);
            localStorage.setItem('EndDate', endDateToSet.toISOString());
        }

        // Call fetchAccountCardDashboard after updating the end date
        const startOfYear = new Date(Date.UTC(currentStartDate.getUTCFullYear(), 0, 1, 0, 0, 0, 0));
        fetchAccountCardDashboard(isMonthly ? currentStartDate : startYearDate, endDateToSet, processedFilesCheckbox);
    };

    //for item edit
    function formatDate(input) {
        const [datePart, timePart] = input.split(' ');
        const [day, month, year] = datePart.split('/');
        const date = new Date(year, month - 1, day);
        if (timePart) {
            const [hours, minutes, seconds] = timePart.split(':');
            date.setHours(hours, minutes, seconds, 0);
        }
        return date.toISOString().slice(0, 19) + '.000';
    }



    //payment functions
    const [openInvoiceCreatorModal, setOpenInvoiceCreatorModal] = useState(false);
    const [addEditableItem, setAddEditableItem] = useState({
        checks: [],
        creditCards: [],
        cash: [],
        bankTransactions: [],
        date: new Date()
    });
    const [modalVisible, setModalVisible] = useState(false);
    const [itemEditing, setItemEditing] = useState(true);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const isClosedReportingMonthAndIsRange = !isRange ? isClosedReportingMonth : addEditableItem.isClosedReportingMonth;
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [paymentAcceptanceItems, setPaymentAcceptanceItems] = useState([]);
    const [accountCodeName, setAccountCodeName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [accountType, setAccountType] = useState(null);
    const [description, setDescription] = useState('');
    const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] = useState(false);
    const [acceptedWithholdingTax, setAcceptedWithholdingTax] = useState(0);
    const [palCode, setPalCode] = useState('');
    const [paymentWithholdingTax, setPaymentWithholdingTax] = useState(0);
    const [newItem, setNewItem] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [actionType, setActionType] = useState('delete');
    const [accountCardIdToDelete, setAccountCardIdToDelete] = useState('');
    const [paymentBeingEdited, setPaymentBeingEdited] = useState(true);





    const handleAddAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLoading(true);
            const response = await EnumsService.AddAccountCard(client.caseId, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const accountCodeId = await response.json();
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };

                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                setAccountCardOptions(prevCards => {
                    const updatedCards = [...prevCards, selectedAccountCard];
                    setIsUpdated(true);
                    return updatedCards;
                });

                toast.success(t('CustomerSupplierAddedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('Failed to edit user', errorText);
                toast.error(t('FailedToAddCustomerSupplier'));
            }
        } catch (error) {
            console.error('Error edit user:', error);
            toast.error(t('FailedToAddCustomerSupplier'));
        }
        setLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };
    const handleAddEditableItemChange = (name, value) => {
        setAddEditableItem(prev => ({ ...prev, [name]: value }));

    };

    const patchAddEditableItem = useCallback((patch) => {
        setAddEditableItem(prev => ({ ...prev, ...patch }));
    }, []);

    async function fetchDataOnDateRangeChange(startDate, endDate) {

        setLoading(true)
        const formattedStartDate = startDate.toISOString();
        const formattedEndDate = endDate.toISOString();

        try {
            const response = await DocumentService.GetDocumentbyDateRange(type, client.caseId, formattedStartDate, formattedEndDate, token)
            if (response.ok) {
                const data = await response.json(); // Parse the JSON in the response
                extractVatByType(data);
                setData(data);
                // toast.success(t('documentFetchSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentFetchError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentFetchError', { errorText: error.message }));
        }

        setLoading(false)
    }
    const [oldSelectedAccountCardItem, setOldSelectedAccountCardItem] = useState({
        cardId: "",
        caseId: "",
        accountCaseId: "",
        name: "",
        palCode: '',
        client: null
    });
    const [originalTaxClearance, setOriginalTaxClearance] = useState(null);
    const [openReportModal, setOpenReportModal] = useState(false);
    const [openProfitAndLossCardsReport, setOpenProfitAndLossCardsReport] = useState(false);
    /**
     * Period and filters the ledger below is currently showing. Recorded by
     * fetchAccountCardDashboard so report modals always read the same period as the data on
     * screen, and follow along whenever it is changed from the filter bar.
     */
    const [appliedReportFilters, setAppliedReportFilters] = useState(null);
    const extractVatByType = (data) => {


        // Sum the WithholdingTax based on PaymentAcceptanceType
        let acceptedWithholdingSum = 0;
        let paymentWithholdingSum = 0;
        let creditSum = 0;
        let debitSum = 0;
        let total = 0;
        data.forEach(doc => {

            if (doc.paymentAcceptanceType === 'תקבול') {
                acceptedWithholdingSum += doc.withholdingTax || 0;
            } else if (doc.paymentAcceptanceType === 'תשלום') {
                paymentWithholdingSum += doc.withholdingTax || 0;
            }
            total += doc.amount
            creditSum += doc.creditAccountAmount || 0;
            debitSum += doc.debitAccountAmount || 0;
        });
        let diff = debitSum - creditSum;
        setAcceptedWithholdingTax(acceptedWithholdingSum);
        setPaymentWithholdingTax(paymentWithholdingSum);
    };

    const CustomPalCode = (props) => {
        return (
            <components.Option {...props}>
                <div style={{ textAlign: 'center', width: '100%' }}>{props.label}</div>
            </components.Option>
        );
    };

    const setAccount = (field, input) => {
        //switch case on field
        switch (field) {
            case 'companyId':
                setCompanyId(input);
                setInvoiceClientCaseId(input);

                break;
            case 'accountCodeName':
                setAccountCodeName(input);

                break;
            case 'accountCodeId':
                setAccountCodeId(input);

                break;
            default:

        }
    }

    const checkIfExistingAccountCard = (accountCardOptions, cardId, accountCaseId, edit = false) => {
        const existingAccountCard = accountCardOptions.filter(card =>
            (card.accountCaseId === accountCaseId && accountCaseId) ||
            (card.cardId === cardId && cardId)
        );
        const isExist = existingAccountCard && (edit
            ? existingAccountCard.length > 1
            : existingAccountCard.length > 0);
        if (isExist) {
            toast.info(t('AccountCardExists', { accountCodeId: existingAccountCard.cardId }));
            return true;
        }
    }
    const fetchDocuments = async (selectedDate) => {
        setLoading(true);
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));

        try {
            const response = await DocumentService.GetDocumentbyDate(type, client.caseId, newDate, token)
            const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);

            if (response.ok && response1.ok) {
                const data = await response.json(); // Parse the JSON in the response
                const isClosedReportingMonth = await response1.json();
                setIsClosedReportingMonth(isClosedReportingMonth);
                extractVatByType(data);
                setData(data);
                // toast.success(t('fetchDocumentsSuccess'));
            } else {
                const errorText = await response.text();
            }
        } catch (error) {

            toast.error(t('errorFetchingDocuments'));
        }
        setLoading(false);
    };

    const handleCloseAddNewAccountCardDocument = () => {
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };
    const onRefresh = async () => {
        setLoading(true);
        await fetchUserData();
        // if (!isRange)
        //     fetchDocuments(sortDate);
        // else
        //     fetchDataOnDateRangeChange(startDate, endDate)
        await fetchEnums(user, token, client);
    };
    const handleSave = async () => {


        try {
            setModalVisible(false);
            setOpenInvoiceCreatorModal(false);
            setLoading(true);
            // Prepare the data to be sent in the request body
            const updatedDocument = buildPaymentAcceptanceUpdatePayload(addEditableItem);


            // Call the UpdateDocument function from DocumentService
            const response = await DocumentService.UpdateDocument("PaymentAcceptances", token, updatedDocument);

            if (response.ok) {
                // Handle successful update — ClientDocumentCounts API uses "Checks" for payment acceptances
                const documentCountType = 'Checks';
                if (addEditableItem.status === 'done') {
                    await handleDoneClick(addEditableItem.id, documentCountType);
                } else if (addEditableItem.status === 'notDone') {
                    await handleNotDoneClick(addEditableItem.id, documentCountType);
                }
                toast.success(t('documentUpdateSuccess'));
                await fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox);
            } else {
                // Handle any errors or display an error message
                toast.error(t('documentUpdateError'));
            }
        } catch (error) {
            console.error('documentUpdateError:', error);
            // Show an error toast message
            toast.error(t('documentUpdateError'));
        }
        await onRefresh();
        // handleClose(); // Function to revert or exit the edit mode
        setLoading(false);

    };

    const handleSaveEditAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId, true)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLoading(true)

            const response = await EnumsService.UpdateAccountCard(client.caseId, oldSelectedAccountCardItem.cardId, oldSelectedAccountCardItem.name, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };
                setAccountCardOptions(prevCards => {
                    const updatedCards = prevCards.filter(card => card.cardId !== selectedAccountCard.cardId);
                    updatedCards.push(selectedAccountCard);
                    setIsUpdated(true);
                    return updatedCards;
                });
                // handleReopenEdit(editedItem);
                toast.success(t('CustomerSupplierUpdatedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('FailedToUpdateCustomerSupplier', errorText);
                toast.error(t('FailedToUpdateCustomerSupplier'));
            }
        } catch (error) {
            console.error('FailedToUpdateCustomerSupplier:', error);

            toast.error(t('FailedToUpdateCustomerSupplier'));

        }
        setLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
        setShowAccountCardInputsEdit(false);
    };



    const handleItemChange = (type, index, field, value) => {
        setPaymentAcceptanceItems(prevItems => {
            let typeIndex = -1;
            const updatedItems = prevItems.map((item, idx) => {
                if (item.type === type) {
                    typeIndex += 1;
                    if (typeIndex === index) {
                        return { ...item, [field]: value };
                    }
                }
                return item;
            });

            // Update the corresponding field in addEditableItem
            setAddEditableItem(prevItem => {
                const updatedTypeItems = prevItem[type].map((item, idx) => {
                    if (idx === index) {
                        return { ...item, [field]: value };
                    }
                    return item;
                });

                // Conditionally update the fields based on payment type and field
                const paymentType = addEditableItem.paymentAcceptanceType;
                const shouldUpdateFields =
                    (paymentType === 'תקבול' && field === 'creditAccount') ||
                    (paymentType === 'תשלום' && field === 'debitAccount');

                const matchingOption = accountCardOptions.find(
                    option => option.cardId === value
                );

                const updatedFields = shouldUpdateFields && matchingOption
                    ? {
                        accountCaseId: matchingOption.accountCaseId || '',
                        accountCodeId: matchingOption.cardId || '',
                        accountCodeName: matchingOption.name || '',
                    }
                    : {};

                return { ...prevItem, ...updatedFields, [type]: updatedTypeItems };
            });

            return updatedItems;
        });
    };
    const handleChangeAccountType = (selectedOption) => {
        setAccountType(selectedOption.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            paymentAcceptanceType: selectedOption ? selectedOption.value : ''
        }));
    };


    const setPaymentDate = async (date) => {
        // const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        // const isClosedReportingMonth = await response1.json();
        // if (isClosedReportingMonth) {
        //     toast.error(t('MonthReportAlreadyClosedTryAgain'));
        //     return
        // }
        setAddEditableItem((prevItem) => ({
            ...prevItem,
            date: date.toISOString()
        }));
    }
    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            description: event.target.value || ''
        }));
    };
    const handleChangeOriginalTaxClearance = (event) => {
        const raw = event.target.value.trim();      // always a string
        const normalised = raw === '' ? 0        // user cleared the field
            : Number(raw) // otherwise turn to number

        // Use the proper state update pattern
        handleAddEditableItemChange('withholdingTax', normalised);
        // setOriginalTaxClearance(value);
    };

    const handleRemoveItem = (type, index) => {
        let count = 0;

        // Update paymentAcceptanceItems
        const newItems = paymentAcceptanceItems.filter(item => {
            if (item.type === type) {
                if (count === index) {
                    count++;
                    return false;
                }
                count++;
            }
            return true;
        });
        setPaymentAcceptanceItems(newItems);

        // Update addEditableItem
        setAddEditableItem(prevItem => {
            if (!Array.isArray(prevItem[type])) return prevItem;
            const updatedTypeItems = prevItem[type].filter((_, idx) => idx !== index);
            return { ...prevItem, [type]: updatedTypeItems };
        });
    };

    const handleAddItem = (theType, suggestedAmount = '', accountFields = {}) => {
        const paymentType = addEditableItem.paymentAcceptanceType;

        const newItem = {
            type: theType,
            description: '',
            amount: suggestedAmount,
            paymentDate: new Date(),
            bankName: '',
            bankCode: '',
            bankBranchCode: '',
            supplierAccountNumber: '',
            bankTransactionsCode: caseSystemSettings.generalBankCardId,
            creditAccount: paymentType === 'תקבול' ? addEditableItem.accountCodeId || '' : '',
            debitAccount: paymentType === 'תשלום' ? addEditableItem.accountCodeId || '' : '',
            ...accountFields,
        };

        // Update paymentAcceptanceItems
        setPaymentAcceptanceItems(prevItems => [...prevItems, newItem]);

        // Update addEditableItem
        setAddEditableItem(prevItem => ({
            ...prevItem,
            [theType]: Array.isArray(prevItem[theType]) ? [...prevItem[theType], newItem] : [newItem]
        }));

    };
    useEffect(() => {
        let unionArray = [];
        if (addEditableItem) {
            unionArray = [
                ...(addEditableItem.checks || []),
                ...(addEditableItem.creditCards || []),
                ...(addEditableItem.cash || []),
                ...(addEditableItem.bankTransactions || [])
            ];
        }

        if (unionArray.length > 0) {
            const allAmountsFilled = unionArray.every(item => item.amount !== undefined && item.amount !== null && item.amount !== '');
            const allFieldsFilled = allAmountsFilled &&
                (addEditableItem.accountCaseId !== undefined && addEditableItem.accountCaseId !== null && addEditableItem.accountCaseId !== '' ||
                    addEditableItem.accountCodeId !== undefined && addEditableItem.accountCodeId !== null && addEditableItem.accountCodeId !== '' ||
                    addEditableItem.accountCodeName !== undefined && addEditableItem.accountCodeName !== null && addEditableItem.accountCodeName !== '') &&
                addEditableItem.paymentAcceptanceType !== undefined && addEditableItem.paymentAcceptanceType !== null && addEditableItem.accountType !== '';



            setButtonDisabled(!allFieldsFilled);
        } else {
            setButtonDisabled(true);
        }
    }, [addEditableItem, accountCodeId, accountType]);



    const handleEdit = (transaction, index, options = {}) => {
        const fromPlReport = !!options.fromPlReport;
        editFromPlReportRef.current = fromPlReport;
        if (!fromPlReport) {
            editOpenedAsProcessedRef.current = false;
        }

        const rowIndex = index !== undefined && index >= 0
            ? index
            : filteredAndSortedTransactions.findIndex((t) => t.id === transaction?.id || t.ID === transaction?.id);
        setCurrentItem(transaction, rowIndex >= 0 ? rowIndex : undefined, { fromPlReport });
    };

    const handleEditFromPlReport = (transaction) => {
        handleEdit(transaction, undefined, { fromPlReport: true });
    };


    const handleMuiChange = (event, value) => {

        if (value?.value1 === 'AddItem') {
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            setAddNewAccountCardDocument(true);
            setAddNewAccountCard(true);
        }
        else {
            setItemEditing(true);
            const updatedFields = {
                accountCaseId: value.accountCaseId,
                accountCodeId: value.cardId,
                accountCodeName: value.name,
            };

            setAccountCodeName(value.name);
            setCompanyId(value.accountCaseId);
            setAccountCodeId(value.cardId);
            setInvoiceClientCaseId(value.cardId);

            // Update addEditableItem state
            setAddEditableItem(prevState => ({
                ...prevState,
                ...updatedFields,
            }));
            setSelectedOption({ ...value });

            // Call the function to update items
            updateAllItems(value, updatedFields);
        }
        // else {
        //     setItemEditing(true);
        //     setAccountCodeName(value.name);
        //     setCompanyId(value.accountCaseId);
        //     // const accountCodeId = accountCardOptions.find(option => option.name === selectedOption.value);
        //     setAccountCodeId(value.cardId);
        //     setInvoiceClientCaseId(value.cardId);
        //     addEditableItem.accountCaseId = value.accountCaseId;
        //     addEditableItem.accountCodeId = value.cardId;
        //     addEditableItem.accountCodeName = value.name;
        //     // Conditionally set creditAccount or debitAccount based on paymentAcceptanceType
        //     if (addEditableItem.paymentAcceptanceType === 'תקבול') {
        //         addEditableItem.creditAccount = value.name;
        //         setSelectedOption({ ...value, disableCreditAccount: true, disableDebitAccount: false });
        //     } else if (addEditableItem.paymentAcceptanceType === 'תשלום') {
        //         addEditableItem.debitAccount = value.name;
        //         setSelectedOption({ ...value, disableDebitAccount: true, disableCreditAccount: false });
        //     }
        // }


    };
    const updateAllItems = (value, updatedFields) => {
        const updatedItems = ['checks', 'bankTransactions', 'creditCards', 'cash'];
        const paymentType = addEditableItem.paymentAcceptanceType;

        updatedItems.forEach(itemType => {
            addEditableItem[itemType]?.forEach((item, index) => {
                // Determine the field to update
                const fieldToUpdate = paymentType === 'תקבול' ? 'creditAccount' : 'debitAccount';

                handleItemChange(itemType, index, fieldToUpdate, value.cardId);
            });
        });

        // Update addEditableItem with new account data
        setAddEditableItem(prevState => ({
            ...prevState,
            ...updatedFields,
        }));
    };
    const handleAccountEdit = (option) => {
        setShowAccountCardInputsEdit(true);
        setAccountCodeName(option.name);
        setAccountCodeId(option.cardId);
        setCompanyId(option.caseId);
        const account = accountCardOptions.find(account => account.cardId === option.cardId);
        setPalCode(account ? account.palCode : '');
        setOldSelectedAccountCardItem({
            cardId: option.cardId,
            caseId: option.caseId,
            accountCaseId: option.accountCaseId,
            name: option.name,
            palCode: '',
            client: null

        })
        setAddNewAccountCardDocument(true);
    };

    const handleAccountDelete = (option) => {
        setActionType('deleteAccountCard');
        setAccountCardIdToDelete(option.cardId);
        setIsModalVisible(true);
        // handleAccountCardDeleteClick(option.cardId);
    };


    const handleClose = async (clearDocuments = true) => {
        setOpenInvoiceCreatorModal(false);
        setPaymentModal(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            date: new Date()
        });
    }
    const [paymentModal, setPaymentModal] = useState(false);

    const setCurrentItem = async (transaction, rowIndex, options = {}) => {
        try {
            
            let type = transaction.type1



            let myItem;

             

            // Check if transactionDetailsDictionary has the item with the transaction ID
            if (transactionDetailsDictionary[transaction.id]) {
                myItem = transactionDetailsDictionary[transaction.id];
                if (!myItem.docType && type) {
                    myItem.docType = type;
                }
                
            } else {
                // If not, make an API call to fetch the item
                let response;
                if (transaction.type1 === 'JournalEntries') {
                    response = await DocumentService.GetDocumentById('JournalEntries', client.caseId, transaction.id, token);
                    type = transaction.type1;
                } else {
                    response = await DocumentService.GetDocumentById(type, client.caseId, transaction.id, token);
                }

                if (response.ok) {
                    myItem = await response.json();
                    myItem.docType = type;

                    // Store the fetched item in transactionDetailsDictionary with the transaction ID as key
                    const updatedDictionary = { ...transactionDetailsDictionary };
                    updatedDictionary[transaction.id] = myItem;
                    setTransactionDetailsDictionary(updatedDictionary);
                } else {
                    console.error('Error fetching document details');
                    return; // Exit the function if the API call fails
                }
            }

            // Recompute status (Processed/Unprocessed) for both cached and freshly fetched items
            // so navigation via next/previous reflects the new item's actual status.
            {
                const itemType = myItem?.docType || type;
                const documentIds = client?.documentIds || {};
                let statusChecked = false;

                if (itemType === "Incomes") {
                    statusChecked = (documentIds.incomes || []).includes(myItem.id);
                } else if (itemType === "JournalEntries") {
                    statusChecked = (documentIds.journalEntries || []).includes(myItem.id);
                } else if (itemType === "Expenses") {
                    statusChecked = (documentIds.expenses || []).includes(myItem.id);
                } else {
                    statusChecked = (documentIds.checks || []).includes(myItem.id);
                }

                // statusCheck true = Processed (id not in the unprocessed documentIds list)
                const openedAsProcessed = !statusChecked;
                setStatusCheck(openedAsProcessed);

                if (options.fromPlReport !== undefined) {
                    editFromPlReportRef.current = !!options.fromPlReport;
                }
                if (editFromPlReportRef.current) {
                    editOpenedAsProcessedRef.current = openedAsProcessed;
                } else {
                    editOpenedAsProcessedRef.current = false;
                }
            }

            // Load the previous and next items asynchronously without await
            loadSurroundingItems(rowIndex, type, filteredAndSortedTransactions);

            if (!type.includes("PaymentAcceptances")) {
                if (transaction.type1 !== 'JournalEntries') {
                    setCurrentIndex(rowIndex);
                    setItemToDelete({ id: myItem.id, type: myItem.docType });
                    setEditedItem({ ...myItem });
                    setEditedPopupItem(true);
                    setEditedJournalItem(false);
                    setPaymentModal(false);
                } else {
                    setCurrentIndex(rowIndex);
                    setItemToDelete({ id: myItem.id, type: myItem.docType });
                    setEditedItem({ ...myItem });
                    setEditedPopupItem(true);
                    setEditedJournalItem(true);
                    setPaymentModal(false);
                }
            }
            else {
                // Extract the type and id from the transaction
                

                // setShowType({ type: itemType, index: -1 })
                setItemToDelete({ id: myItem.id, type: myItem.docType });
                setCurrentIndex(rowIndex);
                setOpenInvoiceCreatorModal(true);
                setAddEditableItem({ ...myItem });
                setPaymentModal(true);
                setEditedJournalItem(false);
                setEditedPopupItem(false);
                setItemEditing(true);
            }

            // else {
            //     

            // setCurrentIndex(rowIndex);
            // setOpenInvoiceCreatorModal(true);
            // setAddEditableItem({ ...myItem });
            // setPaymentModal(true);
            // setEditedJournalItem(false);
            // setEditedPopupItem(false);
            // }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };

    // Function to load the surrounding items (previous and next)
    const loadSurroundingItems = (rowIndex, type, transactionArray) => {
        return new Promise((resolve, reject) => {
            const updatedDictionary = { ...transactionDetailsDictionary };
            const promises = [];

            // Load the previous transaction if it exists and is not already loaded
            if (rowIndex > 0 && !transactionDetailsDictionary[transactionArray[rowIndex - 1].id]) {
                const previousPromise = DocumentService.GetDocumentById(transactionArray[rowIndex - 1].type, client.caseId, transactionArray[rowIndex - 1].id, token)
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) {
                            data.docType = transactionArray[rowIndex - 1].type;
                            updatedDictionary[transactionArray[rowIndex - 1].id] = data;
                            setTransactionDetailsDictionary(updatedDictionary);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching previous transaction:', error);
                        reject(error);
                    });

                promises.push(previousPromise);
            }

            // Load the next transaction if it exists and is not already loaded
            if (rowIndex < transactionArray.length - 1 && !transactionDetailsDictionary[transactionArray[rowIndex + 1].id]) {
                const nextPromise = DocumentService.GetDocumentById(transactionArray[rowIndex + 1].type, client.caseId, transactionArray[rowIndex + 1].id, token)
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) {
                            data.docType = transactionArray[rowIndex + 1].type;
                            updatedDictionary[transactionArray[rowIndex + 1].id] = data;
                            setTransactionDetailsDictionary(updatedDictionary);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching next transaction:', error);
                        reject(error);
                    });

                promises.push(nextPromise);
            }

            // Resolve when all promises are complete
            Promise.all(promises).then(() => resolve()).catch(error => reject(error));
        });
    };


    const getItemAtIndex = (transactions, newIndex) => {
        // Convert the object to an array of its values
        const transactionsArray = Object.values(transactions);

        // Check if the index is within the bounds of the array
        if (newIndex >= 0 && newIndex < transactionsArray.length) {
            return transactionsArray[newIndex];
        } else {
            console.error('Index out of bounds');
            return null;
        }
    };


    const [firstRowDetails, setFirstRowDetails] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [accountCardsData, setAccountCardsData] = useState([]); // Store accountCards array separately
    const [showZeros, setShowZeros] = useState(true); // Filter for showing/hiding zeros
    const [rowViewMode, setRowViewMode] = useState(
        () => localStorage.getItem('AccountCardRowViewMode') || ROW_VIEW_MODES.FULL
    );
    useEffect(() => {
        localStorage.setItem('AccountCardRowViewMode', rowViewMode);
    }, [rowViewMode]);
    const isSummaryView = rowViewMode === ROW_VIEW_MODES.SUMMARY;
    const viewTransactions = useMemo(
        () => (isSummaryView ? collapseAccountCardRows(transactions) : transactions),
        [isSummaryView, transactions]
    );
    const viewAccountCards = useMemo(
        () => (isSummaryView
            ? accountCardsData.map((card) => ({ ...card, transactions: collapseAccountCardRows(card.transactions || []) }))
            : accountCardsData),
        [isSummaryView, accountCardsData]
    );
    // How much the Summary view folded away, so the screen says why it shows fewer rows.
    const summaryMergeInfo = useMemo(() => {
        if (!isSummaryView) return { groups: 0, rows: 0 };
        const rows = accountCardsData.length > 0
            ? viewAccountCards.flatMap((card) => card.transactions || [])
            : viewTransactions;
        const groups = (rows || []).filter((row) => row._summary);
        return {
            groups: groups.length,
            rows: groups.reduce((total, row) => total + (row._count || 0), 0),
        };
    }, [isSummaryView, accountCardsData, viewAccountCards, viewTransactions]);

    const [selectedCardsForReport, setSelectedCardsForReport] = useState([]); // Selected cards from table for report generation

    /* ---------------- Bulk edit (select + edit all) ---------------- */
    const [openBulkEdit, setOpenBulkEdit] = useState(false);
    const [bulkPalCode, setBulkPalCode] = useState('');
    const [bulkSortCode, setBulkSortCode] = useState('');
    const [bulkAutoProcessed, setBulkAutoProcessed] = useState(false);
    const [bulkSourceDeduction, setBulkSourceDeduction] = useState('');
    const [bulkDeductionType, setBulkDeductionType] = useState('');
    const [bulkTaxAssessor, setBulkTaxAssessor] = useState('');
    const [bulkDeductionRate, setBulkDeductionRate] = useState('');
    const [bulkDeductionValidity, setBulkDeductionValidity] = useState('');
    const [bulkPaymentTermsType, setBulkPaymentTermsType] = useState('');
    const [bulkPaymentTermsDays, setBulkPaymentTermsDays] = useState('');

    const handleNext = () => {
        let newIndex = currentIndex;

        while (newIndex < filteredAndSortedTransactions.length - 1) {
            newIndex += 1;
            const nextItem = getItemAtIndex(filteredAndSortedTransactions, newIndex);
            const currentItem = getItemAtIndex(filteredAndSortedTransactions, currentIndex);
            // Check if the next item has a different id
            if (nextItem.id !== currentItem.id) {
                setCurrentItem(nextItem, newIndex);
                break;  // Exit the loop once a different ID is found
            }
        }
    };

    const handlePrevious = () => {
        let newIndex = currentIndex;

        while (newIndex > 0) {
            newIndex -= 1;
            const previousItem = getItemAtIndex(filteredAndSortedTransactions, newIndex);
            const currentItem = getItemAtIndex(filteredAndSortedTransactions, currentIndex);

            // Check if the previous item has a different id
            if (previousItem.id !== currentItem.id) {
                setCurrentItem(previousItem, newIndex);
                break;  // Exit the loop once a different ID is found
            }
        }
    };

    const [dataForPdf, setDataForPdf] = useState(null);
    const [sortedDataForPdf, setSortedDataForPdf] = useState(null);

    const [transactionDetailsDictionary, setTransactionDetailsDictionary] = useState({});

    const filteredAndSortedTransactions = useMemo(() => {
        if (!viewTransactions || viewTransactions.length === 0) {
            return [];
        }
 
 
        // Filtering the transactions based on searchQuery
        const filteredData = viewTransactions.filter((transaction) => {
            if (!searchQuery || searchQuery.trim() === '') {
                return true; // Show all if search is empty
            }
            
            const query = searchQuery.toLowerCase().trim();
            
            // Search in all transaction fields
            return (
                // Transaction fields
                transaction?.description?.toLowerCase().includes(query) ||
                transaction?.reference1?.toLowerCase().includes(query) ||
                transaction?.reference2?.toLowerCase().includes(query) ||
                transaction?.debitAccount?.toString().includes(query) ||
                transaction?.creditAccount?.toString().includes(query) ||
                transaction?.balance?.toString().includes(query) ||
                new Date(transaction.documentDate).toLocaleDateString().toLowerCase().includes(query) ||
                new Date(transaction.uploadDate).toLocaleDateString().toLowerCase().includes(query) ||
                // Card-related fields (added to transactions in fetchAccountCardDashboard)
                transaction?.cardId?.toString().toLowerCase().includes(query) ||
                transaction?.cardName?.toLowerCase().includes(query) ||
                transaction?.palCode?.toLowerCase().includes(query) ||
                // Account name fields
                transaction?.creditAccountName?.toLowerCase().includes(query) ||
                transaction?.debitAccountName?.toLowerCase().includes(query) ||
                // Type field
                transaction?.type1?.toLowerCase().includes(query) ||
                transaction?.docType?.toLowerCase().includes(query)
            );
        });
 
        // Sorting the filtered transactions based on sortConfig
        if (sortConfig.key) {
            filteredData.sort((a, b) => {
                const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined
 
                if (sortConfig.type === 'number') {
                    return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                } else if (sortConfig.type === 'date') {
                    return sortConfig.direction === 'ascending'
                        ? new Date(aValue) - new Date(bValue)
                        : new Date(bValue) - new Date(aValue);
                } else { // default to string comparison
                    return sortConfig.direction === 'ascending'
                        ? aValue?.localeCompare(bValue)
                        : bValue?.localeCompare(aValue);
                }
            });
        }
        const updatedDataForPdf = {
            ...dataForPdf,
            transactions: filteredData,
        };
        setSortedDataForPdf(updatedDataForPdf);
 
        return filteredData;
    }, [viewTransactions, searchQuery, sortConfig]);



    const [palCodeDetails, setPalCodeDetails] = useState('');
    const [hasValidPalCodes, setHasValidPalCodes] = useState(false);

    const [finalBalance, setFinalBalance] = useState('');
    
    const fetchAccountCardDashboard = async (startDate, endDate, processedFilesCheckbox, currencyOverride = undefined) => {
        // Allow callers (e.g. the currency selector) to pass the new currency directly,
        // since React state updates are not visible synchronously on the same tick.
        const currencyToUse = currencyOverride !== undefined ? currencyOverride : selectedCurrency;
        // 'MIXED' means "show all foreign currencies" -> no single-currency filter on the backend
        // (each row keeps its own currency); a numeric value filters to that currency.
        const currencyFilterForApi = currencyToUse === 'MIXED' ? null : currencyToUse;

        setLoading(true);
        try {

            const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                ? endDate
                : new Date(Date.UTC(startDate.getFullYear(), 11, 31));
            setEndDate(finalEndDate);

            // Recorded before the card-selection early returns: report modals cover the whole
            // case, so an empty card selection must not leave them without a period.
            setAppliedReportFilters((previous) => {
                const next = {
                    startDate,
                    endDate: finalEndDate,
                    isMonthly,
                    onlyProcessed: processedFilesCheckbox,
                    filterByDocumentDate,
                };
                return isSameReportFilters(previous, next) ? previous : next;
            });

            // Determine fetch type and prepare data based on FilterBar component logic
            let fetchType;
            let accountCardIds = [];
            let accountCardNames = [];
            let palCodes = [];
            let palCodeTypes = [];

            // Helper function to filter cards by PAL code
            const getFilteredCardsByPalCode = (cards) => {
                if (!cards || cards.length === 0) return [];
                
                // If PAL code is explicitly selected, filter cards by PAL code
                if (palCodeSelectionMode === 'type' && selectedPalCodeType?.value) {
                    const typePalCodes = palCodeOptions
                        .filter(pal => pal.palCodeType === selectedPalCodeType.value)
                        .map(pal => pal.value);
                    return cards.filter(card => {
                        if (!card.palCode || card.palCode.trim() === '') {
                            return typePalCodes.includes('NonPalCode');
                        }
                        return typePalCodes.includes(card.palCode);
                    });
                } else if (palCodeSelectionMode === 'single' && selectedPalCode && selectedPalCode.length > 0) {
                    const selectedPalCodeValues = selectedPalCode.map(pal => pal.value);
                    return cards.filter(card => {
                        if (!card.palCode || card.palCode.trim() === '') {
                            return selectedPalCodeValues.includes('NonPalCode');
                        }
                        return selectedPalCodeValues.includes(card.palCode);
                    });
                } else if (palCodeSelectionMode === 'range' && fromPalCode && toPalCode) {
                    const fromIndex = palCodeOptions.findIndex(pal => pal.value === fromPalCode.value);
                    const toIndex = palCodeOptions.findIndex(pal => pal.value === toPalCode.value);
                    
                    if (fromIndex !== -1 && toIndex !== -1) {
                        const start = Math.min(fromIndex, toIndex);
                        const end = Math.max(fromIndex, toIndex);
                        const rangePalCodes = palCodeOptions.slice(start, end + 1).map(pal => pal.value);
                        return cards.filter(card => {
                            if (!card.palCode || card.palCode.trim() === '') {
                                return rangePalCodes.includes('NonPalCode');
                            }
                            return rangePalCodes.includes(card.palCode);
                        });
                    }
                }
                
                // If no PAL code filter is active, return all cards
                return cards;
            };

            // Validate and filter selected cards based on PAL code before sending
            let validatedAccountCardId = accountCardId;
            let validatedAccountCardName = accountCardName;
            let validatedSelectedCards = selectedCards;

            // For single card mode, validate that the card matches the PAL code filter
            if (cardSelectionMode === 'single' && accountCardId) {
                const selectedCard = allAccountCards.find(card => card.cardId === accountCardId);
                if (selectedCard) {
                    const filteredCards = getFilteredCardsByPalCode([selectedCard]);
                    if (filteredCards.length === 0) {
                        // Card doesn't match PAL code filter, clear the selection
                        validatedAccountCardId = null;
                        validatedAccountCardName = null;
                    }
                } else {
                    // Card not found in allAccountCards, clear the selection
                    validatedAccountCardId = null;
                    validatedAccountCardName = null;
                }
            }

            // For multiple/range card modes, filter out cards that don't match PAL code
            if ((cardSelectionMode === 'multiple' || cardSelectionMode === 'range') && selectedCards && selectedCards.length > 0) {
                validatedSelectedCards = getFilteredCardsByPalCode(selectedCards);
            }

            // Map FilterBar card selection modes to FetchType
            if (cardSelectionMode === 'single' && validatedAccountCardId) {
                // Single card selection - FetchType.Single (1)
                fetchType = 1;
                accountCardIds = [validatedAccountCardId];
                accountCardNames = [validatedAccountCardName];
            } else if (cardSelectionMode === 'multiple' && validatedSelectedCards && validatedSelectedCards.length > 0) {
                // Multiple card selection - FetchType.Multi (3) with validated selected cards
                fetchType = 3;
                accountCardIds = validatedSelectedCards.map(card => card.cardId);
                accountCardNames = validatedSelectedCards.map(card => card.name);
            } else if (cardSelectionMode === 'range' && fromCard && toCard && validatedSelectedCards && validatedSelectedCards.length > 0) {
                // Range card selection - FetchType.Multi (3) with validated selected cards
                fetchType = 3;
                accountCardIds = validatedSelectedCards.map(card => card.cardId);
                accountCardNames = validatedSelectedCards.map(card => card.name);
            } else if (cardSelectionMode === 'all') {
                // All cards - FetchType.All (2) - send all cards and all PAL codes
                fetchType = 2;
                
                // When cardSelectionMode is 'all', send all cards without PAL code filtering
                accountCardIds = [];
                accountCardNames = [];
            } else {
                // Default fallback - FetchType.All (2)
                // fetchType = 2;
                // accountCardIds = [];
                // accountCardNames = [];
            }

            // Handle PAL code selection based on FilterBar PAL code modes
            if (cardSelectionMode === 'all') {
                // When cardSelectionMode is 'all', send all PAL codes
                palCodes = [];
            } else if (palCodeSelectionMode === 'type' && selectedPalCodeType?.value) {
                palCodeTypes = [selectedPalCodeType.value];
                palCodes = [];
                if (!fetchType) {
                    fetchType = 2;
                }
            } else if (palCodeSelectionMode === 'single' && selectedPalCode && selectedPalCode.length > 0) {
                // For single PAL code mode, always send only the selected PAL code(s)
                palCodes = selectedPalCode.map(pal => pal.value);
            } else if (palCodeSelectionMode === 'range' && (fromPalCode && toPalCode)) {
                // Range PAL code selection
                // Prefer selectedPalCode if it's already calculated (from useEffect), otherwise calculate it
                if (selectedPalCode && selectedPalCode.length > 0) {
                    // Use the already calculated selectedPalCode from the useEffect
                    palCodes = selectedPalCode.map(pal => pal.value);
                } else {
                    // Fallback: calculate the range if selectedPalCode is not available
                    const fromIndex = palCodeOptions.findIndex(pal => pal.value === fromPalCode.value);
                    const toIndex = palCodeOptions.findIndex(pal => pal.value === toPalCode.value);
                    
                    if (fromIndex !== -1 && toIndex !== -1) {
                        const start = Math.min(fromIndex, toIndex);
                        const end = Math.max(fromIndex, toIndex);
                        palCodes = palCodeOptions.slice(start, end + 1).map(pal => pal.value);
                    }
                }
            } else if (palCodeSelectionMode === 'all') {
                // All PAL codes - don't filter by PAL code
                palCodes = [];
            } else {
                // No PAL code explicitly selected - check each validated selected card's PAL code
                if (cardSelectionMode === 'single' && validatedAccountCardId) {
                    // Single card mode - check if the validated selected card has a PAL code
                    const selectedCard = allAccountCards.find(card => card.cardId === validatedAccountCardId);
                    if (selectedCard && selectedCard.palCode && selectedCard.palCode.trim() !== '') {
                        palCodes = [selectedCard.palCode];
                    } else {
                        palCodes = ['NonPalCode'];
                    }
                } else if (cardSelectionMode === 'range' && validatedSelectedCards && validatedSelectedCards.length > 0) {
                    // Range card mode - check PAL codes for all validated selected cards
                    const cardPalCodes = validatedSelectedCards.map(card => {
                        if (card.palCode && card.palCode.trim() !== '') {
                            return card.palCode;
                        } else {
                            return 'NonPalCode';
                        }
                    });
                    // Remove duplicates and filter out null/undefined values
                    palCodes = [...new Set(cardPalCodes.filter(Boolean))];
                } else if (cardSelectionMode === 'multiple' && validatedSelectedCards && validatedSelectedCards.length > 0) {
                    // Multiple card mode - check PAL codes for all validated selected cards
                    const cardPalCodes = validatedSelectedCards.map(card => {
                        if (card.palCode && card.palCode.trim() !== '') {
                            return card.palCode;
                        } else {
                            return 'NonPalCode';
                        }
                    });
                    // Remove duplicates and filter out null/undefined values
                    palCodes = [...new Set(cardPalCodes.filter(Boolean))];
                } else {
                    // Fallback to palCodeName or 'NonPalCode'
                    palCodes = palCodeName ? [palCodeName] : [];
                }
            }

            // Update state if validated cards differ from current selection
            if (cardSelectionMode === 'single' && validatedAccountCardId !== accountCardId) {
                setAccountCardId(validatedAccountCardId);
                setAccountCardName(validatedAccountCardName);
            }
            
            if ((cardSelectionMode === 'multiple' || cardSelectionMode === 'range') && 
                validatedSelectedCards && 
                validatedSelectedCards.length !== (selectedCards?.length || 0)) {
                // Update selectedCards to match validated cards
                setSelectedCards(validatedSelectedCards);
            }

            // If no valid cards remain after PAL code filtering, clear state and don't send the request
            if (cardSelectionMode === 'single' && !validatedAccountCardId) {
                setLoading(false);
                setTransactions([]);
                setAccountCardsData([]);
                setFirstRowDetails(null);
                return;
            }
            
            if ((cardSelectionMode === 'multiple' || cardSelectionMode === 'range') && (!validatedSelectedCards || validatedSelectedCards.length === 0)) {
                setLoading(false);
                setTransactions([]);
                setAccountCardsData([]);
                setFirstRowDetails(null);
                return;
            }

 

            // Use the new FetchType-based API call
            const response = await EnumsService.AccountCardPalCodeDetailsWithFetchType(
                accountCardIds,
                accountCardNames,
                palCodes,
                client.accountantId,
                client.caseId,
                startDate,
                finalEndDate,
                !isMonthly,
                processedFilesCheckbox,
                fetchType,
                token,
                filterByDocumentDate,
                currencyFilterForApi,
                palCodeTypes
            );

            if (response?.ok) {
                const result = await response.json();

                // Keep the currency selector list in sync with what the backend found.
                setAvailableCurrencies(Array.isArray(result.availableCurrencies) ? result.availableCurrencies : []);
                
                let allTransactions = [];
                let totalCreditAmount = 0;
                let totalDebitAmount = 0;
                let totalBalance = 0;

                // Handle the new response format with accountCards array
                if (result.accountCards && result.accountCards.length > 0) {
                    // Process multiple account cards from the response
                    result.accountCards.forEach(accountCard => {
                        if (accountCard.transactions && accountCard.transactions.length > 0) {
                            // Add account card identifiers to each transaction
                            const cardTransactions = accountCard.transactions.map(transaction => ({
                                ...transaction,
                                cardId: accountCard.accountCardId,
                                cardName: accountCard.accountCardName,
                                palCode: accountCard.palCode
                            }));
                            allTransactions.push(...cardTransactions);
                        }
                        
                        totalCreditAmount += accountCard.creditAccountAmount || 0;
                        totalDebitAmount += accountCard.debitAccountAmount || 0;
                    });
                    
                    // Sort combined transactions by date
                    allTransactions.sort((a, b) => new Date(a.documentDate) - new Date(b.documentDate));
                    
                    // Calculate final balance
                    totalBalance = totalDebitAmount - totalCreditAmount;
                } else {
                    // Fallback for single account card response (backward compatibility)
                    allTransactions = result.transactions || [];
                    totalCreditAmount = result.creditAccountAmount || 0;
                    totalDebitAmount = result.debitAccountAmount || 0;
                    totalBalance = result.balance || 0;
                }

                // Set final balance for single card reports
                if (cardSelectionMode === 'single' || (result.accountCards && result.accountCards.length === 1)) {
                    const finalBalanceValue = allTransactions?.length
                        ? allTransactions[allTransactions.length - 1].balance?.toFixed(2) || "0"
                        : "0";
                    setFinalBalance(finalBalanceValue);
                }

                // Enhance account cards with PAL code details
                if (result.accountCards && result.accountCards.length > 0) {
                    try {
                        // Check if the response already contains array-based PAL code details
                        if (result.palCode && Array.isArray(result.palCode) && 
                            result.palCodeCategory && Array.isArray(result.palCodeCategory)) {
                            
                            // Use the array-based response data directly
                            const enhancedAccountCards = result.accountCards.map(accountCard => {
                                if (!accountCard.palCode || accountCard.palCode.trim() === '') {
                                    return {
                                        ...accountCard,
                                        palCodeCategory: '-',
                                        palCodeAccountGroup: '-',
                                        palCodeType: '-'
                                    };
                                }
                                
                                // Find the index of this PAL code in the palCode array
                                const palCodeIndex = result.palCode.findIndex(pal => pal === accountCard.palCode);
                                
                                if (palCodeIndex !== -1) {
                                    // Get the corresponding values from the same index in other arrays
                                    const palCodeCategory = result.palCodeCategory[palCodeIndex] || '-';
                                    const palCodeAccountGroup = result.palCodeAccountGroup && Array.isArray(result.palCodeAccountGroup) 
                                        ? result.palCodeAccountGroup[palCodeIndex] || '-'
                                        : result.palCodeAccountGroup || '-';
                                    const palCodeType = result.palCodeType && Array.isArray(result.palCodeType)
                                        ? result.palCodeType[palCodeIndex] || '-'
                                        : result.palCodeType || '-';
                                    
                                    return {
                                        ...accountCard,
                                        palCodeCategory: palCodeCategory,
                                        palCodeAccountGroup: palCodeAccountGroup,
                                        palCodeType: palCodeType
                                    };
                                } else {
                                    // PAL code not found in the array, use fallback
                                    return {
                                        ...accountCard,
                                        palCodeCategory: accountCard.palCode,
                                        palCodeAccountGroup: '-',
                                        palCodeType: '-'
                                    };
                                }
                            });
                            
                            // Filter out account cards with empty PAL codes if desired
                            // Uncomment the next line if you want to exclude account cards without PAL codes
                            // result.accountCards = enhancedAccountCards.filter(card => card.palCode && card.palCode.trim() !== '');
                            
                            // Update the result with enhanced account cards
                            result.accountCards = enhancedAccountCards;
                            // Store accountCards separately for the collapsible table
                            setAccountCardsData(enhancedAccountCards);
                            
                        } else {
                            // Fallback: Fetch PAL code details from API if not available in response
                            const uniquePalCodes = [...new Set(result.accountCards.map(card => card.palCode).filter(Boolean))];
                            
                            if (uniquePalCodes.length > 0) {
                                // Fetch PAL codes details
                                const palCodesResponse = await EnumsService.GetPalCodesByAccountantId(client.accountantId, token);
                                if (palCodesResponse.ok) {
                                    const palCodesData = await palCodesResponse.json();
                                    
                                    // Fetch PAL code categories details
                                    const palCodeCategoriesResponse = await EnumsService.GetPalCodeCategoriesByAccountantId(client.accountantId, token);
                                    if (palCodeCategoriesResponse.ok) {
                                        const palCodeCategoriesData = await palCodeCategoriesResponse.json();
                                        
                                        // Create a mapping of PAL code to its details
                                        const palCodeDetailsMap = {};
                                        const palCodeCategoryDetailsMap = {};
                                        
                                        // Map PAL codes to their details
                                        palCodesData.forEach(palCode => {
                                            palCodeDetailsMap[palCode.palCodeId] = palCode;
                                        });
                                        
                                        // Map PAL code categories to their details
                                        palCodeCategoriesData.forEach(category => {
                                            palCodeCategoryDetailsMap[category.palCodeCategoryId] = category;
                                        });
                                        
                                        // Enhance account cards with PAL code details
                                        const enhancedAccountCards = result.accountCards.map(accountCard => {
                                            if (!accountCard.palCode || accountCard.palCode.trim() === '') {
                                                return {
                                                    ...accountCard,
                                                    palCodeCategory: '-',
                                                    palCodeAccountGroup: '-',
                                                    palCodeType: '-'
                                                };
                                            }
                                            
                                            const palCodeDetails = palCodeDetailsMap[accountCard.palCode];
                                            const palCodeCategoryDetails = palCodeDetails ? palCodeCategoryDetailsMap[palCodeDetails.palCodeCategory] : null;
                                            
                                            return {
                                                ...accountCard,
                                                palCodeCategory: palCodeDetails?.palCodeCategory || accountCard.palCode,
                                                palCodeAccountGroup: palCodeCategoryDetails?.accountingGroup || 'N/A',
                                                palCodeType: palCodeDetails?.palCodeType || 'N/A'
                                            };
                                        });
                                        
                                        // Update the result with enhanced account cards
                                        result.accountCards = enhancedAccountCards;
                                        // Store accountCards separately for the collapsible table
                                        setAccountCardsData(enhancedAccountCards);
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        console.error('Error enhancing PAL code details:', error);
                        // Continue without PAL code details if there's an error
                    }
                }

                // Create appropriate description based on selection mode
                let description;
                if (cardSelectionMode === 'single') {
                    // For single mode, get description from the first account card
                    description = result.accountCards && result.accountCards.length > 0 
                        ? result.accountCards[0].description 
                        : `${t('NoCardSelected')}`;
                } else if (cardSelectionMode === 'range') {
                    description = `${fromCard?.name || 'N/A'} - ${toCard?.name || 'N/A'}`;
                } else if (cardSelectionMode === 'all') {
                    description = `${t(result.accountCards[0].description)} ${t('To')} (${selectedCards.length} ${t('Cards')}) `;
                } else {
                    description = `${t(result.accountCards[0].description)} ${t('To')} (${selectedCards.length} ${t('Cards')}) `;
                }

                const firstRow = {
                    creditAccountAmount: totalCreditAmount,
                    debitAccountAmount: totalDebitAmount,
                    balance: totalBalance,
                    description: description,
                };

                setFirstRowDetails(firstRow);
                setTransactions(allTransactions);
                
                // Store accountCards - prefer the enhanced version, otherwise use the original
                if (result.accountCards && result.accountCards.length > 0) {
                    setAccountCardsData(result.accountCards);
                    
                    // Update accountCardId and accountCardName when PAL code is selected
                    // This happens when PAL code selection mode is 'single' and cards are fetched from PAL code
                    // Update to the first card from the fetched cards
                    if (palCodeSelectionMode === 'single' && selectedPalCode && selectedPalCode.length > 0 && result.accountCards.length > 0) {
                        const firstCard = result.accountCards[0];
                        setAccountCardId(firstCard.accountCardId);
                        setAccountCardName(firstCard.accountCardName);
                    }
                } else if (accountCardsData.length === 0 && result.accountCards) {
                    // Fallback: ensure we have accountCards stored even if enhancement failed
                    setAccountCardsData(result.accountCards);
                    
                    // Update accountCardId and accountCardName when PAL code is selected
                    if (palCodeSelectionMode === 'single' && selectedPalCode && selectedPalCode.length > 0 && result.accountCards.length > 0) {
                        const firstCard = result.accountCards[0];
                        setAccountCardId(firstCard.accountCardId);
                        setAccountCardName(firstCard.accountCardName);
                    }
                }

                //for getting surrounding items
                const newDictionary = {};
                allTransactions.forEach(transaction => {
                    newDictionary[transaction.id] = null;
                });
                setTransactionDetailsDictionary(newDictionary);

                const resultData = {
                    transactions: allTransactions,
                    creditAccountAmount: totalCreditAmount,
                    debitAccountAmount: totalDebitAmount,
                    balance: totalBalance
                };

                // Check if any of the fetched account cards have valid PAL codes
                const cardsHavePalCodes = result.accountCards.some(card => 
                    card.palCode && card.palCode.trim() !== '' && card.palCode.trim().toLowerCase() !== 'nonpalcode'
                );
                setHasValidPalCodes(cardsHavePalCodes);

                const dataForPdf = {
                    clientName: client.name,
                    clientCase: client.caseId,
                    caseType: client.caseType,
                    startDate: startDate,
                    EndDate: endDate,
                    filterByDocumentDate,
                    accountCard: cardSelectionMode === 'single' ? accountCardName : 
                               cardSelectionMode === 'range' ? `${fromCard?.name } - ${toCard?.name }` :
                               cardSelectionMode === 'multiple' ? `Multi-Card (${selectedCards.length} cards)` :
                               cardSelectionMode === 'all' ? 'All Account Cards' : 'Account Card Dashboard',
                    // Add card ID information for the report
                    accountCardId: cardSelectionMode === 'single' ? accountCardId : 
                                  cardSelectionMode === 'range' ? `${fromCard?.cardId } עד כרטיס ${toCard?.cardId }` :
                                  cardSelectionMode === 'multiple' ? selectedCards.map(card => card.cardId).join(', ') :
                                  cardSelectionMode === 'all' ? 'All Cards' : '-',
                    // Add card name information for the report
                    accountCardName: cardSelectionMode === 'single' ? accountCardName : 
                                   cardSelectionMode === 'range' ? `${fromCard?.name || ''} - ${toCard?.name || ''}` :
                                   cardSelectionMode === 'multiple' ? selectedCards.map(card => card.name).join(', ') :
                                   cardSelectionMode === 'all' ? 'All Account Cards' : 'N/A',
                    // Add PAL code information
                    palCodeRange: palCodeSelectionMode === 'type' && selectedPalCodeType?.value
                                 ? selectedPalCodeType.value
                                 : palCodeSelectionMode === 'range' && fromPalCode && toPalCode ? 
                                 `${fromPalCode.value} עד סעיף ${toPalCode.value}` :
                                 palCodeSelectionMode === 'single' && selectedPalCode && selectedPalCode.length > 0 ?
                                 selectedPalCode.map(pal => pal.value).join(', ') :
                                 palCodeName || 'N/A',
                    // Include the accountCards array from the API response for the report
                    accountCards: result.accountCards || [],
                    ...resultData,
                };

                setDataForPdf(dataForPdf);
                setSortedDataForPdf(dataForPdf);
            }
        } catch (error) {
            console.error("Error in API call:", error);
            toast.error(`${t('ErrorFetchReportCardDataReturned')}`);
        }

        //Pal Details - Only fetch if cards have valid PAL codes
        try {
            // Skip PAL code details fetching if no valid PAL codes exist
            if (!hasValidPalCodes) {
                setPalCodeDetails('');
                setLoading(false);
                return;
            }
            
            // Determine PAL code details based on selection mode and FetchType
            let palCodesToFetch = [];
            let fetchType = 1; // Default to Single
            let palDetailsToSet = null;
            
            if (palCodeSelectionMode === 'type' && selectedPalCodeType?.value) {
                palCodesToFetch = palCodeOptions
                    .filter(pal => pal.palCodeType === selectedPalCodeType.value)
                    .map(pal => pal.value);
                fetchType = palCodesToFetch.length > 1 ? 3 : 1;
            } else if (palCodeSelectionMode === 'range' && fromPalCode && toPalCode) {
                // Range mode - get PAL codes in range
                const fromIndex = palCodeOptions.findIndex(pal => pal.value === fromPalCode.value);
                const toIndex = palCodeOptions.findIndex(pal => pal.value === toPalCode.value);
                
                if (fromIndex !== -1 && toIndex !== -1) {
                    const start = Math.min(fromIndex, toIndex);
                    const end = Math.max(fromIndex, toIndex);
                    palCodesToFetch = palCodeOptions.slice(start, end + 1).map(pal => pal.value);
                    fetchType = 3; // Multi
                }
            } else if (palCodeSelectionMode === 'single' && selectedPalCode && selectedPalCode.length > 0) {
                // Single mode - use selected PAL code (always fetchType = 1 for single mode)
                palCodesToFetch = selectedPalCode.map(pal => pal.value);
                fetchType = 1; // Always Single for single mode
            } else if (palCodeSelectionMode === 'all') {
                // All PAL codes
                fetchType = 2; // All
            } else {
                // No PAL code explicitly selected - determine PAL codes from card selection
                let detectedPalCodes = [];
                
                if (cardSelectionMode === 'single' && accountCardId) {
                    // Single card mode - check if the selected card has a PAL code
                    const selectedCard = allAccountCards.find(card => card.cardId === accountCardId);
                    if (selectedCard && selectedCard.palCode && selectedCard.palCode.trim() !== '') {
                        detectedPalCodes = [selectedCard.palCode];
                    } else {
                        detectedPalCodes = ['NonPalCode'];
                    }
                } else if (cardSelectionMode === 'range' && selectedCards && selectedCards.length > 0) {
                    // Range card mode - check PAL codes for all selected cards
                    const cardPalCodes = selectedCards.map(card => {
                        if (card.palCode && card.palCode.trim() !== '') {
                            return card.palCode;
                        } else {
                            return 'NonPalCode';
                        }
                    });
                    // Remove duplicates and filter out null/undefined values
                    detectedPalCodes = [...new Set(cardPalCodes.filter(Boolean))];
                } else if (cardSelectionMode === 'multiple' && selectedCards && selectedCards.length > 0) {
                    // Multiple card mode - check PAL codes for all selected cards
                    const cardPalCodes = selectedCards.map(card => {
                        if (card.palCode && card.palCode.trim() !== '') {
                            return card.palCode;
                        } else {
                            return 'NonPalCode';
                        }
                    });
                    // Remove duplicates and filter out null/undefined values
                    detectedPalCodes = [...new Set(cardPalCodes.filter(Boolean))];
                }
                
                if (detectedPalCodes && detectedPalCodes.length > 0) {
                    palCodesToFetch = detectedPalCodes;
                    if (detectedPalCodes.length === 1) {
                        fetchType = 1; // Single
                    } else {
                        fetchType = 3; // Multi
                    }
                } else {
                    // Fallback to location state or palCodeName
                    const fallbackPalCode = location.state?.palCodeName || palCodeName;
                    if (fallbackPalCode) {
                        palCodesToFetch = [fallbackPalCode];
                        fetchType = 1; // Single
                    }
                }
            }
            
            // Call the enhanced PAL code details API
            const response = await EnumsService.GetPalcodesDetailsByAccountCard(
                client.accountantId, 
                palCodesToFetch.length > 0 ? palCodesToFetch[0] : null, 
                token,
                palCodesToFetch.length > 1 ? palCodesToFetch : null,
                fetchType
            );
            
            if (response.ok) {
                const palDetailsResponse = await response.json();
                
                // Handle the new array-based response format with unique values
                if (palDetailsResponse.palCode && Array.isArray(palDetailsResponse.palCode)) {
                    // New format with arrays for each property (now with unique values)
                    const palCodeDetails = {
                        palCode: palDetailsResponse.palCode[0] || '',
                        palCodeCategory: palDetailsResponse.palCodeCategory[0] || '',
                        palCodeAccountGroup: palDetailsResponse.palCodeAccountGroup[0] || '',
                        accountingGroupClassifaction: palDetailsResponse.accountingGroupClassifaction[0] || '',
                        palCodeType: palDetailsResponse.palCodeType[0] || ''
                    };
                    
                    palDetailsToSet = palCodeDetails;
                    
                    // Store the full response for potential future use
                    setPalCodeDetails(palDetailsResponse);
                } else if (palDetailsResponse.palCodeDetails && Array.isArray(palDetailsResponse.palCodeDetails)) {
                    // Old array format with multiple PAL codes
                    palDetailsToSet = palDetailsResponse.palCodeDetails[0] || {}; // Use first for backward compatibility
                    
                    // Store all PAL code details for potential future use
                    setPalCodeDetails(palDetailsResponse.palCodeDetails);
                } else {
                    // Old format with single PAL code
                    palDetailsToSet = palDetailsResponse;
                    setPalCodeDetails([palDetailsResponse]);
                }
                
                // Update PDF data with PAL code details
                // For the report, we need to pass the full array-based response, not just the first element
                const reportPalDetails = palDetailsResponse.palCode && Array.isArray(palDetailsResponse.palCode) 
                    ? palDetailsResponse  // Use the full array-based response
                    : palDetailsToSet;    // Fallback to single object for old format
                
                setDataForPdf(prevData => ({
                    ...reportPalDetails,
                    ...prevData
                }));
                setSortedDataForPdf(prevData => ({
                    ...reportPalDetails,
                    ...prevData
                }));

            } else {
                console.error('There is no balance sheet item', response.statusText);
                toast.info(t('There is no balance sheet item'));
            }
        } catch (error) {
            console.error('Error fetching PAL code details:', error);
            toast.error(t('MissingInformationForAction'));
        }
        setLoading(false);
    };

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input document-custom-input-range `} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));



    const handleGoBack = () => {

        if (client) {

            // handleBack();
            goBack();
        }
    };
    const [palCodeName, setPalCodeName] = useState(null);
    const [accountCardName, setAccountCardName] = useState(null);
    const [accountCardId, setAccountCardId] = useState(null);
    
    // New state variables for card range selection
    const [selectedCards, setSelectedCards] = useState([]);
    const [allAccountCards, setAllAccountCards] = useState([]);
    const [cardSelectionMode, setCardSelectionMode] = useState('single'); // 'single', 'range', 'multiple', 'all'
    const [fromCard, setFromCard] = useState(null);
    const [toCard, setToCard] = useState(null);
    const [isMultiCardReport, setIsMultiCardReport] = useState(false);
    const [breadcrumbs, setBreadcrumbs] = useState(['Reports', 'LedgerReport']);
    
    // PAL Code filtering
    const [palCodeOptions, setPalCodeOptions] = useState([]);
    const [selectedPalCode, setSelectedPalCode] = useState([]);
    const [palCodeSelectionMode, setPalCodeSelectionMode] = useState('single');
    const [selectedPalCodeType, setSelectedPalCodeType] = useState(null);
    const [fromPalCode, setFromPalCode] = useState(null);
    const [toPalCode, setToPalCode] = useState(null);
    const [palCodeCategoryOptions, setPalCodeCategoryOptions] = useState([]);
    
    // // Add debounce mechanism to prevent multiple rapid API calls
    // const [fetchTimeout, setFetchTimeout] = useState(null);

    // // Debounced version of fetchAccountCardDashboard
    // const debouncedFetchAccountCardDashboard = (startDate, endDate, processedFilesCheckbox, delay = 300) => {
    //     if (fetchTimeout) {
    //         clearTimeout(fetchTimeout);
    //     }
        
    //     const timeout = setTimeout(() => {
    //         fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox);
    //     }, delay);
        
    //     setFetchTimeout(timeout);
    // };

    const fetchUserData = async () => {
        setLoading(true);
        try {
            const currentUser = await UserService.getCurrentUser();
            const currentToken = await UserService.getCurrentToken();
            if (currentUser && currentToken) {
                setUser(currentUser);
                setToken(currentToken);


                if (location.state && location.state.client) {
                    if (location.state.isSortCodeReport) {
                        isLedgerNavigationRef.current = true;
                        setIsDataFetched(false);
                    }

                    setType("AccountCardDashboard");
                    setClient(location.state.client);
                    
                    // Handle breadcrumbs
                    if (location.state.breadcrumbs) {
                        setBreadcrumbs(location.state.breadcrumbs);
                    }
                    
                    // Handle single card selection (existing functionality)
                    if (location.state.accountCardName && location.state.accountCardId) {
                        setAccountCardName(location.state.accountCardName);
                        setAccountCardId(location.state.accountCardId);
                        setCardSelectionMode('single');
                        setIsMultiCardReport(false);
                    }
                    
                    // Handle multi-card selection (new functionality)
                    if (location.state.selectedCards && location.state.selectedCards.length > 0) {
                        setSelectedCards(location.state.selectedCards);
                        setCardSelectionMode('multiple');
                        setIsMultiCardReport(true);
                    }
                    
                    // Handle card range selection
                    if (location.state.fromCard && location.state.toCard) {
                        setFromCard(location.state.fromCard);
                        setToCard(location.state.toCard);
                        setCardSelectionMode('range');
                        setIsMultiCardReport(true);
                    }
                    
                    // Handle all cards selection
                    if (location.state.selectAllCards) {
                        setCardSelectionMode('all');
                        setIsMultiCardReport(true);
                    }
                }
                
                if (location.state.palCodeName) {
                    setPalCodeName(location.state.palCodeName);
                }

                if (location.state.isMonthly !== undefined) {
                    setIsMonthly(location.state.isMonthly);
                    localStorage.setItem('isMonthly', JSON.stringify(location.state.isMonthly));
                }

                if (location.state.filterByDocumentDate !== undefined) {
                    setFilterByDocumentDate(location.state.filterByDocumentDate);
                }

                if (location.state.startDate && location.state.endDate) {
                    const navStartDate = new Date(location.state.startDate);
                    const navEndDate = new Date(location.state.endDate);
                    setStartDate(navStartDate);
                    setEndDate(navEndDate);

                    if (location.state.isMonthly === false) {
                        setStartYearDate(new Date(Date.UTC(navStartDate.getUTCFullYear(), 0, 1)));
                        setEndYearDate(new Date(Date.UTC(navEndDate.getUTCFullYear(), 11, 31)));
                    }
                }

                await fetchEnums(currentUser, currentToken, location.state.client);

            }
            else {
                navigate("/login");
            }

        } catch (error) {
            console.error("Error fetching user data:", error);
            // navigate("/login");
        }
        setLoading(false);
    };
    useEffect(() => {
        fetchUserData();
    }, [location]);

    useEffect(() => {
        handleDirectNavigation();
    }, []);

    const isValidDate = (value) =>
        value instanceof Date && !isNaN(value);

    useEffect(() => {
        if (!isDataFetched) return;           // wait for enums
        if (!client) return;
        if (!isValidDate(startDate) || !isValidDate(endDate)) {
            console.warn('Invalid date(s) in state:', startDate, endDate);
            return;
        }
        const startOfYear = new Date(Date.UTC(startDate.getUTCFullYear(), 0, 10, 0, 0, 0, 0));
        const endOfYear = new Date(Date.UTC(endDate.getUTCFullYear(), 11, 31, 0, 0, 0, 0));

        setStartYearDate(startOfYear);
        setEndYearDate(endOfYear);

        fetchAccountCardDashboard(isMonthly ? startDate : startOfYear, isMonthly ? endDate : endOfYear, processedFilesCheckbox);
    }, [isDataFetched]);

    // // Cleanup timeout on component unmount
    // useEffect(() => {
    //     return () => {
    //         if (fetchTimeout) {
    //             clearTimeout(fetchTimeout);
    //         }
    //     };
    // }, [fetchTimeout]);

    const handleProcessFilesCheckboxClick = async (isChecked) => {
        try {
            if (isChecked !== null) {
                if (isChecked) {
                    fetchAccountCardDashboard(startDate, endDate, true)
                } else {
                    fetchAccountCardDashboard(startDate, endDate, false)
                }
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
        }

        setProcessedFilesCheckbox(isChecked);
    };






    // let header = getHeader();

    const refreshData = async () => {

        if (!isMonthly) {
            const startYear = startYearDate instanceof Date && !isNaN(startYearDate)
                ? startYearDate.getUTCFullYear()
                : (startDate instanceof Date && !isNaN(startDate) ? startDate.getUTCFullYear() : NaN);
            const endYear = endYearDate instanceof Date && !isNaN(endYearDate)
                ? endYearDate.getUTCFullYear()
                : (endDate instanceof Date && !isNaN(endDate) ? endDate.getUTCFullYear() : NaN);

            if (!startYear || !endYear) {
                console.error('Invalid dates:', startYearDate, endYearDate);
                return;
            }
            // Must use Date.UTC — local `new Date(y, 0, 1)` in Israel becomes prior-year Dec 31 UTC
            const startOfYear = new Date(Date.UTC(startYear, 0, 10, 0, 0, 0, 0));
            const endOfYear = new Date(Date.UTC(endYear, 11, 31, 0, 0, 0, 0));

            await fetchAccountCardDashboard(startOfYear, endOfYear, processedFilesCheckbox);
        }
        else {
            await fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox);
        }
    }







    const handleDeleteClick = () => {
        setIsModalVisible(true);
    };

    const handleEditDeleteClick = (itemId) => {
        setEditedPopupItem(false);
        setEditedItem({});
        setPaymentModal(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            date: new Date()
        });
        handleDeleteClick();
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLoading(true);
        setIsModalVisible(false);
        try {
            const response = await DocumentService.DeleteDocument(itemToDelete.type, itemToDelete.id, token);
            if (response.ok) {
                const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                    ? endDate
                    : new Date(Date.UTC(startDate.getFullYear(), 11, 31));
                setEndDate(finalEndDate);

                await fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox);
                // Show success toast
                toast.success(t("documentDeleteSuccess"));
            } else {
                // Handle any errors or display an error toast
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Show error toast
                toast.error(t("documentDeleteError"));
            }
        } catch (error) {
            console.error('Error deleting document:', error);

            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setLoading(false);
    };


    //table functions
    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };
    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }


    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();

    const handleOpenHTMLModal = async () => {
        // Use selected cards if any are selected, otherwise fall back to accountCardId
        if (selectedCardsForReport && selectedCardsForReport.length > 0) {
            // Generate report for selected cards
            // You may need to update the modal logic to handle multiple cards
            setOpenReportModal(true);
        } else {
            // Fall back to single card behavior
            setOpenReportModal(true);
        }
    };

    const handleGenerateLedgerCardForCard = async (card) => {
        // Select the card and open the GenerateLedgerCard modal
        if (card) {
            // Set the card as selected for the report
            setSelectedCardsForReport([card]);
            setOpenReportModal(true);
        }
    };

    const handleCardMatching = async (card) => {
        // Don't navigate, just handle the card matching action
        // Extract cardId from card object if it's an object, otherwise use it directly
        const cardId = typeof card === 'object' && card !== null
            ? (card.accountCardId || card.cardId)
            : card;
        navigate('/CardMatching', { state: { type: 'CardMatching', client, card: cardId } });
    };

    const handleSelectedCardsChange = (selectedCards) => {
        setSelectedCardsForReport(selectedCards);
    };

    /* Sort-code options shaped for the AutocompleteSelect in BulkEditDialog. */
    const bulkSortCodesOptions = useMemo(
        () => (sortCodeIdOptions || []).map((s) => ({
            value: s.sortCodeId,
            label: s.name ? `${s.sortCodeId} - ${s.name}` : String(s.sortCodeId),
        })),
        [sortCodeIdOptions]
    );

    const selectedCardCodesForBulk = useMemo(
        () => (selectedCardsForReport || [])
            .map((c) => c.accountCardId ?? c.cardId)
            .filter((v) => v != null && v !== '')
            .map(String),
        [selectedCardsForReport]
    );

    const handleCloseBulkEdit = () => setOpenBulkEdit(false);

    const handleOpenBulkEdit = () => {
        if (selectedCardCodesForBulk.length === 0) {
            toast.info(t('SelectAtLeastOneCard', 'Select at least one card first'));
            return;
        }
        setOpenBulkEdit(true);
    };

    const handleBulkEditSave = async () => {
        if (!client?.caseId || !token || selectedCardCodesForBulk.length === 0) {
            handleCloseBulkEdit();
            return;
        }

        const CaseId = client.caseId;
        const codes = selectedCardCodesForBulk;
        let allOk = true;

        try {
            setLoading(true);

            if (bulkPalCode) {
                const res = await EnumsService.EditInBulk(CaseId, codes, bulkPalCode, token);
                if (!res.ok) allOk = false;
            }

            if (userTypeContext?.toString() !== Constants.UserType.Client &&
                (bulkSortCode || bulkAutoProcessed)) {
                const res = await EnumsService.EditSortCodeInBulk(CaseId, codes, bulkSortCode, bulkAutoProcessed, token);
                if (!res.ok) allOk = false;
            }

            const hasSourceDeduction = bulkSourceDeduction !== '' && bulkSourceDeduction !== null && bulkSourceDeduction !== undefined;
            const hasDeductionType = bulkDeductionType !== '' && bulkDeductionType !== null && bulkDeductionType !== undefined;
            const hasTaxAssessor = bulkTaxAssessor !== '' && bulkTaxAssessor !== null && bulkTaxAssessor !== undefined;
            const hasDeductionRate = bulkDeductionRate !== '' && bulkDeductionRate !== null && bulkDeductionRate !== undefined;
            const hasDeductionValidity = bulkDeductionValidity !== '' && bulkDeductionValidity !== null && bulkDeductionValidity !== undefined;
            if (hasSourceDeduction || hasDeductionType || hasTaxAssessor || hasDeductionRate || hasDeductionValidity) {
                const res = await EnumsService.EditDeductionInBulk(
                    CaseId,
                    codes,
                    hasSourceDeduction ? bulkSourceDeduction : null,
                    hasDeductionType ? bulkDeductionType : null,
                    hasTaxAssessor ? bulkTaxAssessor : null,
                    hasDeductionRate ? (parseFloat(bulkDeductionRate) || null) : null,
                    hasDeductionValidity ? bulkDeductionValidity : null,
                    token
                );
                if (!res.ok) allOk = false;
            }

            const hasPaymentTerms = bulkPaymentTermsType !== '' && bulkPaymentTermsType !== null && bulkPaymentTermsType !== undefined;
            if (hasPaymentTerms) {
                const ptType = Number(bulkPaymentTermsType);
                let ptDays = null;
                if (ptType === Constants.PaymentTermsType.Custom) {
                    ptDays = bulkPaymentTermsDays !== '' ? parseInt(bulkPaymentTermsDays, 10) : null;
                } else if (ptType === Constants.PaymentTermsType.Shoteff) {
                    ptDays = null;
                } else {
                    ptDays = ptType;
                }
                const res = await EnumsService.EditPaymentTermsInBulk(CaseId, codes, ptType, ptDays, token);
                if (!res.ok) allOk = false;
            }

            if (allOk) {
                toast.success(t('AccountCardsUpdatedSuccessfully'));
                // Clear the picked values so they aren't accidentally re-applied next time.
                setBulkPalCode('');
                setBulkSortCode('');
                setBulkAutoProcessed(false);
                setBulkSourceDeduction('');
                setBulkDeductionType('');
                setBulkTaxAssessor('');
                setBulkDeductionRate('');
                setBulkDeductionValidity('');
                setBulkPaymentTermsType('');
                setBulkPaymentTermsDays('');
                await fetchEnums(user, token, client);
                await fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox);
            } else {
                toast.error(t('AccountCardsFailedToUpdate'));
            }
        } catch (err) {
            console.error('Dashboard bulk edit error:', err);
            toast.error(t('AccountCardsFailedToUpdate'));
        } finally {
            setLoading(false);
        }

        handleCloseBulkEdit();
    };

    // Function to handle direct navigation from reports menu
    const handleDirectNavigation = () => {
        if (!location.state || !location.state.cardSelectionMode) {
            // If no card selection mode is specified, show the card selection interface
            setCardSelectionMode('single');
            setIsMultiCardReport(false);
        }
    };

    const handleCloseHTMLModal = () => {
        setOpenReportModal(false);
    };

    const handleSortConfigChange = (newSortConfig) => {
        handleSortChange(newSortConfig.key, newSortConfig.type);
    };

    // Table headers - always show all columns
    const [denseTableHeader] = useState([
        t("SelectedCards"),
        t("BalanceClassification"),
        t("BalanceClassificationCategory"),
        t("AccountingGroup")
    ]);

    const [denseTableRows, setDenseTableRows] = useState([]);

    // Update denseTableRows whenever palCodeDetails, selectedCards, or selectedPalCode changes
    useEffect(() => {
        let selectedCardsText = '-';
        let palCodeDetailsText = '-';

        // Format selected cards text
        if (isMultiCardReport && selectedCards.length > 0) {
            if (selectedCards.length === 1) {
                selectedCardsText = `${selectedCards[0].cardId} - ${selectedCards[0].name}`;
            } else if (selectedCards.length >= 2) {
                const firstCard = selectedCards[0];
                const lastCard = selectedCards[selectedCards.length - 1];
                selectedCardsText = `${firstCard.cardId} - ${firstCard.name} ${t('To')} ${lastCard.cardId} - ${lastCard.name} (${selectedCards.length} ${t('Cards')})`;
            }
        } else if (accountCardId && accountCardName) {
            selectedCardsText = `${accountCardId} - ${accountCardName}`;
        }

        // Check if PAL code is actually selected (not just cleared) or detected from cards
        const hasPalCodeSelection = (selectedPalCode && selectedPalCode.length > 0) ||
                                   (palCodeSelectionMode === 'type' && selectedPalCodeType?.value) ||
                                   (palCodeDetails && palCodeDetails.palCode && Array.isArray(palCodeDetails.palCode) && palCodeDetails.palCode.length > 0) ||
                                   (palCodeDetails && Array.isArray(palCodeDetails) && palCodeDetails.length > 0) ||
                                   (palCodeDetails && palCodeDetails.palCode);
        
        // Format PAL code details text only if PAL code is selected
        if (hasPalCodeSelection) {
            if (palCodeSelectionMode === 'type' && selectedPalCodeType?.value) {
                palCodeDetailsText = selectedPalCodeType.label;
            } else if (selectedPalCode && selectedPalCode.length > 0) {
                // Explicitly selected PAL codes
                if (selectedPalCode.length === 1) {
                    palCodeDetailsText = selectedPalCode[0].label;
                } else if (selectedPalCode.length >= 2) {
                    const firstPal = selectedPalCode[0];
                    const lastPal = selectedPalCode[selectedPalCode.length - 1];
                    palCodeDetailsText = `${firstPal.label} ${('-')} ${lastPal.label} (${selectedPalCode.length} ${t('PalCodes')})`;
                }
            } else if (palCodeDetails && palCodeDetails.palCode && Array.isArray(palCodeDetails.palCode)) {
                // Handle new array-based format with unique values - detected from cards
                if (palCodeDetails.palCode.length === 1) {
                    palCodeDetailsText = palCodeDetails.palCode[0] || '-';
                } else {
                    const firstPal = palCodeDetails.palCode[0] || 'N/A';
                    const lastPal = palCodeDetails.palCode[palCodeDetails.palCode.length - 1] || 'N/A';
                    palCodeDetailsText = `${firstPal} ${('-')} ${lastPal} (${palCodeDetails.palCode.length} ${t('PalCodes')})`;
                }
            } else if (palCodeDetails && Array.isArray(palCodeDetails) && palCodeDetails.length > 0) {
                // Handle old array format - detected from cards
                if (palCodeDetails.length === 1) {
                    palCodeDetailsText = palCodeDetails[0].palCode || '-';
                } else {
                    const firstPal = palCodeDetails[0];
                    const lastPal = palCodeDetails[palCodeDetails.length - 1];
                    palCodeDetailsText = `${firstPal.palCode || 'N/A'} ${('-')} ${lastPal.palCode || 'N/A'} (${palCodeDetails.length} ${t('PalCodes')})`;
                }
            } else if (palCodeDetails && palCodeDetails.palCode) {
                // Handle old single object format (backward compatibility) - detected from cards
                palCodeDetailsText = palCodeDetails.palCode;
            }
        }

        // Get PAL code details for display - only if PAL code is actually selected
        let currentPalDetails = null;
        if (hasPalCodeSelection && palCodeDetails && palCodeDetails.palCode && Array.isArray(palCodeDetails.palCode)) {
            // New array-based format with unique values
            // For display, show range format if multiple unique values exist
            const palCodeAccountGroupText = palCodeDetails.palCodeAccountGroup.length > 1 
                ? `${palCodeDetails.palCodeAccountGroup[0]} - ${palCodeDetails.palCodeAccountGroup[palCodeDetails.palCodeAccountGroup.length - 1]}`
                : palCodeDetails.palCodeAccountGroup[0] || '';
                
            const palCodeCategoryText = palCodeDetails.palCodeCategory.length > 1 
                ? `${palCodeDetails.palCodeCategory[0]} - ${palCodeDetails.palCodeCategory[palCodeDetails.palCodeCategory.length - 1]}`
                : palCodeDetails.palCodeCategory[0] || '';

            currentPalDetails = {
                palCode: palCodeDetails.palCode[0] || '',
                palCodeCategory: palCodeCategoryText,
                palCodeAccountGroup: palCodeAccountGroupText,
                accountingGroupClassifaction: palCodeDetails.accountingGroupClassifaction[0] || '',
                palCodeType: palCodeDetails.palCodeType[0] || ''
            };
        } else if (hasPalCodeSelection && Array.isArray(palCodeDetails) && palCodeDetails.length > 0) {
            // Old array format
            currentPalDetails = palCodeDetails[0];
        } else if (hasPalCodeSelection) {
            // Single object format
            currentPalDetails = palCodeDetails;
        }

        // Build row object - always show all columns
        // If no valid PAL codes exist, show '-' for all PAL-related fields
        const rowData = {
            SelectedCards: selectedCardsText,
            BalanceClassification: (hasValidPalCodes && hasPalCodeSelection) ? (palCodeDetailsText || '-') : '-',
            BalanceClassificationCategory: (hasValidPalCodes && hasPalCodeSelection) ? (currentPalDetails?.palCodeCategory || '-') : '-',
            AccountingGroup: (hasValidPalCodes && hasPalCodeSelection) ? (currentPalDetails?.palCodeAccountGroup || '-') : '-'
        };
        
        setDenseTableRows([rowData]);
    }, [palCodeDetails, selectedCards, selectedPalCode, selectedPalCodeType, palCodeSelectionMode, isMultiCardReport, accountCardId, accountCardName, hasValidPalCodes, t]);

    // Clear palCodeDetails when PAL code selection is removed
    useEffect(() => {
        if (!selectedPalCode || selectedPalCode.length === 0) {
            setPalCodeDetails('');
        }
    }, [selectedPalCode]);

    /**
 *  SECOND TABLE:
 *  Summaries for totalCredit, totalDebit, and their Difference
 */
    const [denseTableHeaderTotals] = useState([
        t("Balance"),
        t("TotalCreditAccount"),
        t("TotalDebitAccount"),
    ]);

    const [denseTableRowsTotals, setDenseTableRowsTotals] = useState([
        {
            TotalDebit: 0,
            TotalCredit: 0,
            Difference: 0
        }
    ]);

    useEffect(() => {
        if (!transactions || transactions.length === 0) {
            setDenseTableRowsTotals([
                {
                    Difference: beautifyNumber(firstRowDetails?.balance || 0),
                    TotalCredit: beautifyNumber(0), // No transactions, so total is 0
                    TotalDebit: beautifyNumber(0),  // No transactions, so total is 0
                }
            ]);
            return;
        }

        // Safely reduce with fallback to 0, rounding each value to 2 decimal places before summing
        const totalCreditFromTransactions = transactions.reduce(
            (acc, item) => {
                const roundedValue = Math.round((item?.creditAccount || 0) * 100) / 100;
                return acc + roundedValue;
            },
            0
        );

        const totalDebitFromTransactions = transactions.reduce(
            (acc, item) => {
                const roundedValue = Math.round((item?.debitAccount || 0) * 100) / 100;
                return acc + roundedValue;
            },
            0
        );

        const firstCredit = Math.round((firstRowDetails?.creditAccountAmount || 0) * 100) / 100;
        const firstDebit = Math.round((firstRowDetails?.debitAccountAmount || 0) * 100) / 100;

        // Total debit/credit SHOULD include opening balance (initial amounts + transactions)
        const totalCredit = totalCreditFromTransactions + firstCredit;
        const totalDebit = totalDebitFromTransactions + firstDebit;
        
        // Difference (final balance) SHOULD include opening balance
        const difference = totalDebit - totalCredit;

        setDenseTableRowsTotals([
            {
                Difference: beautifyNumber(difference),
                TotalCredit: beautifyNumber(totalCredit),
                TotalDebit: beautifyNumber(totalDebit),
            }
        ]);
    }, [transactions, firstRowDetails]);
    const fileInputRef = useRef();

    /**
     * Opens the Cash Flow Forecast on the same cards, period and currency that are
     * currently displayed, so the projection continues the ledger being read.
     */
    const handleOpenCashFlowForecast = () => {
        const cardIds = isMultiCardReport && selectedCards?.length
            ? selectedCards.map((card) => card.cardId).filter(Boolean)
            : accountCardId
                ? [accountCardId]
                : [];

        navigate('/CashFlowForecast', {
            state: {
                client,
                type: 'CashFlowForecast',
                cardIds,
                startDate,
                endDate,
                currency: selectedCurrency === 'MIXED' ? null : selectedCurrency,
                breadcrumbs: ['Reports', 'CashFlowForecast'],
            },
        });
    };

    /**
     * Profit & Loss report over the result-account cards of the case, laid out in the same
     * order as the Profit & Loss report of LedgerReport, with the detailed transactions of
     * every card available inline.
     */
    const handleOpenProfitAndLossCardsReport = () => {
        if (!client?.caseId || !appliedReportFilters) {
            toast.info(t('MissingInformationForAction'));
            return;
        }
        setOpenProfitAndLossCardsReport(true);
    };

    const buttonData = [
        {
            label: 'GenerateLedgerCard',
            onClick: () => handleOpenHTMLModal(),
            className: 'create-Invoice-selector',
            chipColor: '#304FFF',
            icon: () => (<DescriptionIcon sx={{ fontSize: 18 }} />),
        },
        {
            label: 'CardMatching',
            onClick: () => handleCardMatching(accountCardId),
            className: 'create-Invoice-selector',
            chipColor: '#304FFF',
            icon: () => (<img src={cardMatchingIcon} alt="" style={{ width: 18, height: 18 }} />),
            style: { maxWidth: 220 },
        },
        {
            // Continues the ledger the user is looking at into the future, keeping the
            // cards, period and currency currently on screen.
            label: 'CashFlowForecast',
            onClick: () => handleOpenCashFlowForecast(),
            className: 'create-Invoice-selector',
            chipColor: '#304FFF',
            icon: () => (<ShowChartIcon sx={{ fontSize: 18 }} />),
            style: { maxWidth: 220 },
        },
        {
            label: 'ProfitAndLossCardsReport',
            onClick: () => handleOpenProfitAndLossCardsReport(),
            className: 'create-Invoice-selector',
            chipColor: '#304FFF',
            icon: () => (<SummarizeIcon sx={{ fontSize: 18 }} />),
            style: { maxWidth: 220 },
        }
    ];


    return (
        <>
            {(addEditableItem && paymentModal) && (
                <PaymentAcceptanceCreateEditModal
                    openInvoiceCreatorModal={openInvoiceCreatorModal}
                    handleClose={handleClose}
                    t={t}
                    itemEditing={itemEditing}
                    addNewAccountCardDocument={addNewAccountCardDocument}
                    companyId={companyId}
                    accountCodeName={accountCodeName}
                    accountCodeId={accountCodeId}
                    setAccount={setAccount}
                    Constants={Constants}
                    palCode={palCode}
                    setPalCode={setPalCode}
                    isRange={isRange}
                    addEditableItem={addEditableItem}  // renamed from editedItem
                    isClosedReportingMonth={isClosedReportingMonth}
                    handleSaveEditAccountCard={handleSaveEditAccountCard}
                    handleAddAccountCard={handleAddAccountCard}
                    handleCloseAddNewAccountCardDocument={handleCloseAddNewAccountCardDocument}
                    accountCardOptions={accountCardOptions}
                    selectedOption={selectedOption}
                    handleMuiChange={handleMuiChange}
                    handleEdit={handleEdit}
                    handleAccountDelete={handleAccountDelete}  // renamed from handleDelete
                    handleChangeAccountType={handleChangeAccountType}
                    customStyles={customStyles}
                    setPaymentDate={setPaymentDate}
                    setReportingMonthDate={setReportingMonthDate}
                    handleDescriptionChange={handleDescriptionChange}
                    handleChangeOriginalTaxClearance={handleChangeOriginalTaxClearance}
                    handleAddEditableItemChange={handleAddEditableItemChange}
                    patchAddEditableItem={patchAddEditableItem}
                    handleItemChange={handleItemChange}
                    handleRemoveItem={handleRemoveItem}
                    showAccountCardInputsEdit={showAccountCardInputsEdit}
                    statusCheck={statusCheck}
                    handleRadioChange={handleRadioPAChange}
                    handleSave={handleSave}
                    buttonDisabled={buttonDisabled}
                    paymentBeingEdited={paymentBeingEdited}
                    CustomDropdown={CustomDropdown}
                    type={type}
                    direction={direction}
                    setAddNewAccountCardDocument={setAddNewAccountCardDocument}
                    fetchEnums={fetchEnums}
                    isClosedReportingMonthAndIsRange={isClosedReportingMonthAndIsRange}
                    handleAddItem={handleAddItem}
                    CustomPalCode={CustomPalCode}
                    handleAccountEdit={handleAccountEdit}
                    handlePrevious={handlePrevious}
                    currentIndex={currentIndex}
                    filteredAndSortedData={filteredAndSortedTransactions}
                    handleNext={handleNext}
                    showType={showType}
                    handleDeleteClick={handleEditDeleteClick}
                    client={client}
                    token={token}
                    setLoading={setLoading}
                    handleTransferRefresh={async () => {
                        await fetchEnums(user, token, client);
                    }}
                />
            )}

            <>
                <>


                    
                    <NavigationButton
                        t={t}
                        direction={direction}
                        fileInputRef={fileInputRef}
                        data={buttonData}
                    />
                    
                    {/* <SelectedCardsTitle
                        isMultiCardReport={isMultiCardReport}
                        selectedCards={selectedCards}
                        accountCardName={accountCardName}
                        accountCardId={accountCardId}
                        direction={direction}
                    /> */}
                    
                    <FilterBar
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        startDate={startDate}
                        endDate={endDate}
                        isMonthly={isMonthly}
                        handleStartDateChange={handleStartDateChange}
                        handleEndDateChange={handleEndDateChange}
                        handleStartDateChangeNew={handleStartDateChangeNew}
                        handleEndDateChangeNew={handleEndDateChangeNew}
                        handleRangeChange={handleRangeChange}
                        processedFilesCheckbox={processedFilesCheckbox}
                        handleProcessFilesCheckboxClick={handleProcessFilesCheckboxClick}
                        allAccountCards={allAccountCards}
                        selectedCards={selectedCards}
                        setSelectedCards={setSelectedCards}
                        cardSelectionMode={cardSelectionMode}
                        setCardSelectionMode={setCardSelectionMode}
                        fromCard={fromCard}
                        setFromCard={setFromCard}
                        toCard={toCard}
                        setToCard={setToCard}
                        accountCardId={accountCardId}
                        setAccountCardId={setAccountCardId}
                        accountCardName={accountCardName}
                        setAccountCardName={setAccountCardName}
                        isMultiCardReport={isMultiCardReport}
                        setIsMultiCardReport={setIsMultiCardReport}
                        palCodeOptions={palCodeOptions}
                        selectedPalCode={selectedPalCode}
                        setSelectedPalCode={setSelectedPalCode}
                        palCodeSelectionMode={palCodeSelectionMode}
                        setPalCodeSelectionMode={setPalCodeSelectionMode}
                        fromPalCode={fromPalCode}
                        setFromPalCode={setFromPalCode}
                        toPalCode={toPalCode}
                        setToPalCode={setToPalCode}
                        selectedPalCodeType={selectedPalCodeType}
                        setSelectedPalCodeType={setSelectedPalCodeType}
                        onApplySelection={() => fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox)}
                        direction={direction}
                        showZeros={showZeros}
                        setShowZeros={setShowZeros}
                        filterByDocumentDate={filterByDocumentDate}
                        setFilterByDocumentDate={setFilterByDocumentDate}
                        rowViewMode={rowViewMode}
                        setRowViewMode={setRowViewMode}
                        availableCurrencies={availableCurrencies}
                        selectedCurrency={selectedCurrency}
                        setSelectedCurrency={(value) => {
                            setSelectedCurrency(value);
                            fetchAccountCardDashboard(startDate, endDate, processedFilesCheckbox, value);
                        }}
                    />
                    
                    <div className='document-Dense-container'  >
                        <DenseTable
                            headers={denseTableHeaderTotals}
                            rows={denseTableRowsTotals}
                            reverse={true}
                            width="100%"
                            headerStyle={{
                                opacity: 0.6,
                                background: "var(--orange, #F9AA2A)",
                                textAlign: "center",
                                minHeight: "50px"
                            }}
                            rowStyle={{
                                borderTop: "1px solid rgba(191, 191, 193, 0.56)",
                                background: "var(--secondary-12, rgba(254, 247, 234, 0.12))",
                                minHeight: "50px"
                            }}
                        />

                        {/* Only show this table if we have data to display (always show for cards info) */}
                        <DenseTable headers={denseTableHeader} rows={denseTableRows} width='100%'
                            reverse={true}
                            headerStyle={{
                                opacity: 0.6,
                                background: 'var(--orange, #F9AA2A)',
                                textAlign: 'center',
                                minHeight: '50px'
                            }}
                            rowStyle={{
                                borderTop: '1px solid rgba(191, 191, 193, 0.56)',
                                background: 'var(--secondary-12, rgba(254, 247, 234, 0.12))',
                                minHeight: '50px'
                            }}
                        />

                    </div>



                    {isSummaryView && (
                        <MuiBox
                            dir={direction}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 1,
                                px: 1.25,
                                py: 0.75,
                                borderRadius: '8px',
                                background: 'rgba(48, 79, 255, 0.08)',
                                border: '1px solid rgba(48, 79, 255, 0.25)',
                                color: '#304FFF',
                                fontSize: 13,
                                fontWeight: 600,
                            }}
                        >
                            <SummarizeIcon sx={{ fontSize: 18 }} />
                            <span>{t('SummaryView')}</span>
                            <span style={{ fontWeight: 500 }}>
                                {summaryMergeInfo.groups > 0
                                    ? t('SummaryViewMergedRows', {
                                        rows: summaryMergeInfo.rows,
                                        groups: summaryMergeInfo.groups,
                                    })
                                    : t('SummaryViewNothingMerged')}
                            </span>
                        </MuiBox>
                    )}

                    {accountCardsData && accountCardsData.length > 0 && (
                        <MuiBox
                            dir={direction}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                mb: 1,
                                px: selectedCardCodesForBulk.length > 0 ? 1 : 0,
                                py: selectedCardCodesForBulk.length > 0 ? 1 : 0,
                                borderRadius: '8px',
                                background: selectedCardCodesForBulk.length > 0
                                    ? 'rgba(48, 79, 255, 0.08)'
                                    : 'transparent',
                                border: selectedCardCodesForBulk.length > 0
                                    ? '1px solid rgba(48, 79, 255, 0.25)'
                                    : '1px solid transparent',
                                transition: 'all 0.2s ease',
                            }}
                        >
                            <span style={{ fontSize: 13, fontWeight: 600, color: '#304FFF' }}>
                                {selectedCardCodesForBulk.length > 0
                                    ? `${selectedCardCodesForBulk.length} ${t('Selected', 'selected')}`
                                    : t('SelectCardsToEdit', 'Select cards to edit them together')}
                            </span>
                            <MuiButton
                                variant="contained"
                                size="small"
                                startIcon={<EditIcon sx={{ fontSize: 16 }} />}
                                disabled={selectedCardCodesForBulk.length === 0}
                                onClick={handleOpenBulkEdit}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    backgroundColor: '#304FFF',
                                    '&:hover': { backgroundColor: '#2539d4' },
                                }}
                            >
                                {t('EditSelected', 'Edit selected')}
                            </MuiButton>
                        </MuiBox>
                    )}

                    {accountCardsData && accountCardsData.length > 0 ? (
                        <AccountCardCollapsibleTable
                            accountCards={viewAccountCards}
                            handleEdit={handleEdit}
                            handleSortChange={handleSortChange}
                            formatDateNew={formatDateNew} 
                            showZeros={showZeros}
                            sortConfig={sortConfig}
                            onSelectedCardsChange={handleSelectedCardsChange}
                            onCardMatchingClick={handleCardMatching}
                            onGenerateLedgerCard={handleGenerateLedgerCardForCard}
                            searchQuery={searchQuery}
                            selectedCurrency={selectedCurrency}
                        />
                    ) : (
                        <AccountCardDashboardTable
                            firstRowDetails={firstRowDetails}
                            filteredAndSortedTransactions={filteredAndSortedTransactions}
                            handleEdit={handleEdit}
                            handleSortChange={handleSortChange}
                            formatDateNew={formatDateNew}
                            selectedCurrency={selectedCurrency}
                        />
                    )}
                </>
                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {/* <HamburgerMenu client={client} /> */}
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}

                <CustomDeleteConfirmationModal
                    isVisible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onDelete={handleConfirmDelete}
                    confirmMessage={t('confirmDeleteMessage')}
                    titleMessage={t('confirmDeleteTitle')}
                />

                {showChooseAsset && (
                    <ChooseAsset
                        date={dateForAsset}
                        open={showChooseAsset}
                        onClose={() => handleAssetClose()}
                        type={editedItem?.docType}
                        itemId={itemToAddToAsset}
                        client={client}
                        token={token}
                        editedItemVat={editedItem.vat}
                        onAssetChosen={(assetId) => {
                            setShowChooseAsset(false);
                        }}
                        onCreateAsset={(newAsset) => {
                            setShowChooseAsset(false);
                        }}
                        fullItem={itemForAssets}
                        saleEquipment={saleEquipment}
                        clickedAsset={clickedAsset}
                        fetchEnums={fetchEnums}
                        user={user}
                        setShowAddGroupModal={handleOpenGroudAdd}
                        assetGroups={assetGroups}

                    />
                )}

                {showAddGroupModal && (
                    <AddAssetGroup
                        open={showAddGroupModal}
                        onClose={() => setShowAddGroupModal(false)}
                        caseId={client.caseId}
                        token={token}
                        assetGroups={assetGroups}
                        refreshAssetGroups={() => {
                            // Refresh the list
                            fetchEnums(user, token, client);
                            setShowAddGroupModal(false);
                        }}
                    />
                )}





                {editedItem && editedPopupItem && Object.keys(editedItem).length > 0 && (

                    <EditModal
                        editedItem={editedItem}
                        fade={fade}
                        handlePrevious={handlePrevious}
                        handleNext={handleNext}
                        currentIndex={currentIndex}
                        filteredAndSortedData={responseData}
                        NoDocumentsPdf={NoDocumentsPdf}
                        t={t}
                        handleAccountChange={handleAccountChange}
                        isRange={isRange}
                        isClosedReportingMonth={isClosedReportingMonth}
                        accountCardOptions={accountCardOptions}
                        handleChange={handleChange}
                        handleDateChange={handleDateChange}
                        CustomInput2={CustomInput2}
                        setReportingMonthDate={setReportingMonthDate}
                        handleVatRadioChange={handleVatRadioChange}
                        statusCheck={statusCheck}
                        handleRadioChange={handleRadioChange}
                        type={type}
                        editedAddAccountCard={editedAddAccountCard}
                        handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                        handleEditAddAccountChange={handleEditAddAccountChange}
                        sortCodeIdOptions={sortCodeIdOptions}
                        debitAccountOptions={debitAccountOptions}
                        creditAccountOptions={creditAccountOptions}
                        handleUpdate={handleUpdate}
                        handleCancel={handleCancel}
                        handleDeleteClick={handleEditDeleteClick}
                        client={client}
                        token={token}
                        setAccountCardOptions={setAccountCardOptions}
                        setLoading={setLoading}
                        setEditedAddAccountCard={setEditedAddAccountCard}
                        setEditedItem={setEditedItem}
                        handleReopenEdit={handleReopenEdit}
                        showIframe={!editedJournalItem}
                        palCodes={formattedPalCodeOptions}
                        fetchEnums={fetchEnums}
                        RefreshPage={refreshData}
                        assets={assets}
                        assetClicked={handleAssetClicked}
                        hideStatus={hideStatusBadge}

                    />
                )}
                <AccountCardReportHTML
                    open={openReportModal}
                    handleClose={handleCloseHTMLModal}
                    data={sortedDataForPdf}
                    initialData={firstRowDetails}
                    onSortConfigChange={handleSortConfigChange}
                    token={token}
                    finalBalance={finalBalance}
                    palCodeCategoryOptions={palCodeCategoryOptions}
                    userTypeContext={userTypeContext}
                    selectedCardsForReport={selectedCardsForReport}
                    selectedCurrency={selectedCurrency}
                />
                <ProfitAndLossCardsReport
                    open={openProfitAndLossCardsReport}
                    handleClose={() => setOpenProfitAndLossCardsReport(false)}
                    client={client}
                    token={token}
                    startDate={appliedReportFilters?.startDate}
                    endDate={appliedReportFilters?.endDate}
                    isMonthly={appliedReportFilters?.isMonthly ?? isMonthly}
                    onlyProcessed={appliedReportFilters?.onlyProcessed ?? processedFilesCheckbox}
                    filterByDocumentDate={appliedReportFilters?.filterByDocumentDate ?? filterByDocumentDate}
                    direction={direction}
                    formatDate={formatDateNew}
                    handleTransactionEdit={handleEditFromPlReport}
                    reloadToken={plReportReloadToken}
                />
                <AssetFoundDialog
                    open={showAssetFoundDialog}
                    asset={foundAsset}
                    assetGroups={assetGroups}
                    onClose={() => setShowAssetFoundDialog(false)}
                    isDraggable={true}            // or false if you don't want drag
                    caseId={client?.caseId}
                    token={token}
                    transactionId={editedItem.id}
                    fetchEnums={fetchEnumsNoParams}
                />

                <BulkEditDialog
                    open={openBulkEdit}
                    onClose={handleCloseBulkEdit}
                    direction={direction}
                    palCodesOptions={palCodeOptions}
                    sortCodesOptions={bulkSortCodesOptions}
                    selectedPalCodeForSelectAll={bulkPalCode}
                    setSelectedPalCodeForSelectAll={setBulkPalCode}
                    selectedSortCodeForSelectAll={bulkSortCode}
                    setSelectedSortCodeForSelectAll={setBulkSortCode}
                    selectedAutoProcessedForSelectAll={bulkAutoProcessed}
                    setSelectedAutoProcessedForSelectAll={setBulkAutoProcessed}
                    selectedSourceDeductionForSelectAll={bulkSourceDeduction}
                    setSelectedSourceDeductionForSelectAll={setBulkSourceDeduction}
                    selectedDeductionTypeForSelectAll={bulkDeductionType}
                    setSelectedDeductionTypeForSelectAll={setBulkDeductionType}
                    selectedTaxAssessorForSelectAll={bulkTaxAssessor}
                    setSelectedTaxAssessorForSelectAll={setBulkTaxAssessor}
                    selectedDeductionRateForSelectAll={bulkDeductionRate}
                    setSelectedDeductionRateForSelectAll={setBulkDeductionRate}
                    selectedDeductionValidityForSelectAll={bulkDeductionValidity}
                    setSelectedDeductionValidityForSelectAll={setBulkDeductionValidity}
                    selectedPaymentTermsTypeForSelectAll={bulkPaymentTermsType}
                    setSelectedPaymentTermsTypeForSelectAll={setBulkPaymentTermsType}
                    selectedPaymentTermsDaysForSelectAll={bulkPaymentTermsDays}
                    setSelectedPaymentTermsDaysForSelectAll={setBulkPaymentTermsDays}
                    onSave={handleBulkEditSave}
                    userTypeContext={userTypeContext}
                />
            </>

        </>
    );
}


export default AccountCardDashboard;
